var ctrlopt = ctrlopt,
  site = site || {},
  generic = generic || {},
  moment = moment || {};

(function ($) {
  var apptBook = Drupal.appointmentBooking;
  var settings = Drupal.settings.globals_variables || {};
  var OAB_start_from_monday = settings.OAB_start_from_monday || 0;
  var oab_show_head_copy_last = settings.oab_show_head_copy_last || 0;
  var oab_show_month_after_year = settings.oab_show_month_after_year || 0;
  var oab_year_suffix = settings.oab_year_suffix || '';
  var oab_day_suffix = settings.oab_day_suffix || '';
  var isDisablePrice = +$('#appointment-book-container').attr('data-disable-price');
  var locale = generic.cookie('LOCALE');

  function startDayShift(day_nr) {
    // monday has to be day 0 in JS logic, so we have to shift all days by one position
    if (OAB_start_from_monday) {
      day_nr = day_nr - 1;
      if (day_nr == -1) {
        // if sunday then assign it to 6
        day_nr = 6;
      }
    }

    return day_nr;
  }

  // padStart polyfill for IE11
  // https://github.com/uxitten/polyfill/blob/master/string.polyfill.js
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padStart
  if (!String.prototype.padStart) {
    String.prototype.padStart = function padStart(targetLength, padString) {
      targetLength = targetLength >> 0; // truncate if number or convert non-number to 0;
      padString = String(typeof padString !== 'undefined' ? padString : ' ');
      if (this.length > targetLength) {
        return String(this);
      } else {
        targetLength = targetLength - this.length;
        if (targetLength > padString.length) {
          // append to original to ensure we are longer than needed
          padString += Array.apply(null, Array(targetLength))
            .map(function () {
              return padString;
            })
            .join('');
        }

        return padString.slice(0, targetLength) + String(this);
      }
    };
  }

  /* Concrete View */
  apptBook.AppointmentSelectSection = function (container) {
    apptBook.AppointmentSelectSection.superclass.constructor.call(this);
    this.id = 'appointments';
    this.jqBod = $('body');
    this.container = container;
    this.servContainer = container.find('.services');
    this.serviceTmpl = this.servContainer.find('.service').remove();
    this.changeServices = container.find('#change-services-link');
    this.backTo = container.find('.back-to-link');
    this.minLabel = this.servContainer.attr('data-time-label');
    this.curSymbol = this.servContainer.attr('data-currency-symbol');
    this.locSelect = container.find('select.location-select');
    this.artContainer = container.find('.artist-select-container');
    this.artSelect = this.artContainer.find('select.artist-select');
    this.apptContainer = container.find('.appointment-select');
    this.calHead = this.apptContainer.find('.calendar-head');
    this.calDayOfWeekFormat = this.calHead.attr('data-cal-DOW-date-format') || 'ddd M/DD';
    this.momentLocale = container.attr('data-moment-locale')
      ? container.attr('data-moment-locale')
      : generic.cookie('LOCALE')
      ? generic.cookie('LOCALE').substr(0, 2)
      : 'en';
    this.signInContainer = container.find('.sign-in-container');
    this.bookContainer = container.find('.book-appt-container');
    this.bookBar = container.find('.book-now-bar');
    this.totalElem = this.bookBar.find('.total-time');
    this.totalText = this.totalElem.html();
    this.startOver = this.bookContainer.find('.start-over');
    this.selErrOverlay = container.find('.appt-book-services-overlay').remove();
    this.bookConflictOverlay = container.find('.appt-book-book-conflict-overlay').remove();
    this.locationConflictOverlay = container.find('.appt-book-location-conflict-overlay').remove();
    this.calendarId = '0';
    this.appointmentId = null;
    this.appointmentTime = null;
    this.totalTime = 0;
    this.totalTimeWithPadding = 0;
    this.slotInterval = 0;
    this.serviceIds = [];
    this.nonSubsequentServicesSelf = [];
    this.subsequentServicesSelf = [];
    this.stores = {};
    this.overlayIsOpen = false;
    this.updateMode = false;
  };

  ctrlopt.extend(apptBook.AppointmentSelectSection, apptBook.AbstractSection);

  apptBook.AppointmentSelectSection.prototype.onUpdate = function (data) {
    var servs,
      servObj,
      hasCounter = false,
      hasCounters = false,
      me = this,
      aPgName = document.title + ' - Appointment Select & Book';

    this.serviceIds = [];
    this.totalTime = 0;
    this.updateMode = false;

    function runUpdate() {
      if (hasCounter && hasCounters) {
        var hasVirtual = localStorage.getItem('virtual_oab') || 0;

        if (hasVirtual) {
          $('.back-to-link', this.container).addClass('hidden');
          $('.selects-container', this.container).addClass('hidden');
          $('.appointment-select > h4', this.container).addClass('hidden');
        }
        me.buildServices();
        me.buildLocation();
        me.buildArtists();
        if (!me.initialized) {
          me.buildApptSelect();
          me.initialized = true;
        } else {
          var date = me.appointmentTime
            ? dateUtils.convertTimeString(me.appointmentTime)
            : new Date();
          var dateSet = me.appointmentTime ? 1 : 0;

          me.calModel.update({
            date: date,
            calendarId: me.calendarId,
            counterId: me.counterId,
            apptDur: me.totalTime,
            timeSlotInterval: me.slotInterval,
            serviceIds: me.serviceIds,
            hilite: true,
            dateSet: dateSet,
            openTimes: me.counterData.opening_time_range,
            subsequentServicesSelf: me.subsequentServicesSelf,
            nonSubsequentServicesSelf: me.nonSubsequentServicesSelf,
            myNonSubsequentDuration: me.myNonSubsequentDuration,
            myNonSubsequentDurationWithPadding: me.myNonSubsequentDurationWithPadding,
            mySubsequentDuration: me.mySubsequentDuration,
            mySubsequentDurationWithPadding: me.mySubsequentDurationWithPadding,
            showNextWeek: true
          });
          if (me.appointmentTime) {
            me.calModel.fire('time_selected', me.appointmentTime);
          } else {
            me.calModel.fire('time_deselected');
          }
        }
      }
    }

    function processUpdate() {
      function updateServiceData() {
        me.mySubsequentDuration = 0;
        me.mySubsequentDurationWithPadding = 0;
        me.myNonSubsequentDuration = 0;
        me.myNonSubsequentDurationWithPadding = 0;
        (me.subsequentServicesSelf = []), (me.nonSubsequentServicesSelf = []);
        for (var i = 0, len = me.servicesData.length; i < len; i += 1) {
          if (me.serviceIds.indexOf(me.servicesData[i].serviceId) === -1) {
            me.serviceIds.push(me.servicesData[i].serviceId);
          }
          if (me.servicesData[i].subsequent === 0) {
            me.myNonSubsequentDuration += me.servicesData[i].serviceDuration;
            me.myNonSubsequentDurationWithPadding += me.servicesData[i].serviceDurationWithPadding;
            me.nonSubsequentServicesSelf.push(me.servicesData[i].serviceId);
          } else {
            me.mySubsequentDuration += me.servicesData[i].serviceDuration;
            me.mySubsequentDurationWithPadding += me.servicesData[i].serviceDurationWithPadding;
            me.subsequentServicesSelf.push(me.servicesData[i].serviceId);
          }
        }
      }

      if (data.params.appointmentId) {
        me.model.getAppointment(
          data.params.appointmentId,
          function (apptData) {
            me.appointmentData = apptData;
            me.updateMode = true;
            me.counterId = me.appointmentData.counter_id;
            me.calendarId = me.appointmentData.calendar_id;
            me.servicesData = [];
            me.appointmentId = apptData.id;
            me.appointmentTime = apptData.start_time;
            me.apptDur = 0;

            servs = me.appointmentData.services;

            for (var i = 0, len = servs.length; i < len; i += 1) {
              servObj = servs[i];
              servObj.price = servObj.price || 0;
              me.servicesData.push({
                serviceId: servObj.id,
                onlineContentId: servObj.online_content_id,
                serviceDuration: servObj.total_duration,
                serviceDurationWithPadding: servObj.total_duration_with_padding,
                servicePrice: servObj.price,
                serviceName: servObj.name
              });

              (me.apptDur += parseInt(servObj.total_duration_with_padding)),
                me.serviceIds.push(servObj.id);
            }

            updateServiceData();

            me.model.getCounter(
              me.counterId,
              { service_id: me.nonSubsequentServicesSelf },
              function (data) {
                me.counterData = data;
                hasCounter = true;
                me.slotInterval = me.counterData.timeslot_interval;
                runUpdate();
              }
            );
          },
          function () {
            // If there is an error retrieving appointment id, go to beginning of APP
            var myUrl = [location.protocol, '//', location.host, location.pathname].join('');

            window.location = myUrl;
          }
        );
      } else {
        if (me.counterId !== data.params.counterId) {
          me.calendarId = '0';
        }
        if (!!data.params.startTime) {
          me.appointmentTime = data.params.startTime;
        }
        if (data.params.updateMode) {
          me.updateMode = true;
          me.calendarId = '0';
        } else {
          me.updateMode = false;
        }
        me.counterId = data.params.counterId;
        me.servicesData = data.params.services;
        updateServiceData();

        me.model.getCounter(
          me.counterId,
          { service_id: me.nonSubsequentServicesSelf },
          function (data) {
            me.counterData = data;
            hasCounter = true;
            runUpdate();
          }
        );
      }

      if (typeof data.params.slotInterval != 'undefined') {
        me.slotInterval = data.params.slotInterval;
      }

      if (!!data.params.appointmentDuration) {
        me.apptDur = data.params.appointmentDuration;
      }

      // We need to split this up, if the user has subsequent and non-subsequent services
      // The counters returned here are used to populate the counter dropdown on the timeslots
      // selection page, but it only returns counters that have a calendar that supports ALL services
      // passed in, which will never be the case with subsequent and non-subsequent since they exist
      // on mutually exclusive calendars
      me.nonSubsequentServices = _.uniq(
        me.nonSubsequentServicesSelf.concat(me.nonSubsequentServicesFriend)
      );
      me.subsequentServices = _.uniq(me.subsequentServicesSelf.concat(me.subsequentServicesFriend));

      if (me.nonSubsequentServices.length > 0 && me.subsequentServices.length > 0) {
        me.model.fetchCountersData({ service_id: me.nonSubsequentServices }, function (data) {
          me.countersData = data;
          me.model.fetchCountersData({ service_id: me.subsequentServices }, function (data) {
            // Combine the data in me.counterData with 'data'. Only keep counters that were present in BOTH sets of data
            var combinedCounters = [];

            for (var j = 0; j < data.length; j++) {
              var subsCounterId = data[j].id;

              for (var k = 0; k < me.countersData.length; k++) {
                if (me.countersData[k].id == subsCounterId) {
                  combinedCounters.push(data[j]);
                  break;
                }
              }
            }
            me.countersData = combinedCounters;
            hasCounters = true;
            runUpdate();
          });
        });
      } else if (me.nonSubsequentServices.length > 0) {
        me.model.fetchCountersData({ service_id: me.nonSubsequentServices }, function (data) {
          me.countersData = data;
          hasCounters = true;
          runUpdate();
        });
      } else {
        me.model.fetchCountersData({ service_id: me.subsequentServices }, function (data) {
          me.countersData = data;
          hasCounters = true;
          runUpdate();
        });
      }
    }

    if (data.sectionId === this.id) {
      generic.jsonrpc.fetch({
        method: 'user.json',
        // params: [],
        onSuccess: function (jsonRpcResponse) {
          me.userData = jsonRpcResponse.getValue();
          processUpdate();
        },
        onFailure: function (jsonRpcResponse) {
          me.userData = null;
          processUpdate();
        }
      });
    }
  };

  apptBook.AppointmentSelectSection.prototype.buildServices = function () {
    var myTmpl,
      sData,
      me = this;

    $(window).on('loadPreviousServicesObjBackButton', function () {
      var upObj = {
        sectionId: 'services',
        params: {
          sectionId: me.id,
          counterId: me.counterId,
          serviceIds: me.serviceIds,
          updateMode: me.updateMode
        }
      };

      return upObj;
    });
    this.servContainer.find('.service').remove();
    for (var i = 0, len = this.servicesData.length; i < len; i += 1) {
      sData = this.servicesData[i];
      sData.servicePrice = sData.servicePrice || 0;
      myTmpl = this.serviceTmpl.clone();
      this.servContainer.append(myTmpl);

      // if (site.client.isMobile) {
      // myTmpl.find('.service-head').text(sData.serviceName + " (" + sData.serviceDuration + " " + this.minLabel + ")");
      // } else {
      // myTmpl.find('.service-head').text(sData.serviceName);
      // myTmpl.find('.selection-time').text(sData.serviceDuration + " " + this.minLabel);
      // }
      if (this.servicesData.length == 1) {
        myTmpl.addClass('only-service-selected');
      }
      var OAB_price_override =
        Drupal.settings.globals_variables.OAB_override_price_format !== 'undefined'
          ? Drupal.settings.globals_variables.OAB_override_price_format
          : 0;
      var servicePrice = parseInt(sData.servicePrice);

      myTmpl.attr('data-service-id', sData.serviceId);
      myTmpl.find('.service-type').append(sData.serviceType);
      if (!sData.serviceType) {
        var allServiceDivs = Drupal.appointmentBooking.servicesCMSData;
        for (var i = 0, len = allServiceDivs.length; i < len; i += 1) {
          if ($(allServiceDivs[i]).data('content-id') == sData.onlineContentId) {
            myTmpl.find('.service-type').append($(allServiceDivs[i]).find('.service-type').html());
          }
        }
      }
      myTmpl.find('.service-head').append(sData.serviceName); // + "<span class='selection-time'>" + sData.serviceDuration + this.minLabel + "</span>" + "<span class='selection-price'>" + this.curSymbol + sData.servicePrice + "</span>");
      myTmpl.find('.selection-time').append(sData.serviceDuration + this.minLabel);
      if (isDisablePrice && !servicePrice) {
        myTmpl.find('.selection-separator').html('');
      } else {
        myTmpl
          .find('.selection-price')
          .append(
            OAB_price_override ? servicePrice + this.curSymbol : this.curSymbol + servicePrice
          );
      }
      var $change_service = myTmpl.find('.js-change-services-link');

      $change_service.attr('aria-label', sData.serviceName + ' ' + $change_service.text());

      this.totalTime += sData.serviceDuration;
      this.totalTimeWithPadding += parseInt(sData.serviceDurationWithPadding);
      this.totalPrice += sData.servicePrice;

      myTmpl.find('#change-services-link').off('click');
      myTmpl.find('#change-services-link').click(function (e) {
        e.preventDefault();
        me.removeService($(this));
      });
      this.backTo.off('click');
      this.backTo.click(function (e) {
        e.preventDefault();

        var upObj = {
          sectionId: 'services',
          params: {
            sectionId: me.id,
            counterId: me.counterId,
            serviceIds: me.serviceIds,
            updateMode: me.updateMode,
            myNonSubsequentDuration: me.myNonSubsequentDuration,
            myNonSubsequentDurationWithPadding: me.myNonSubsequentDurationWithPadding,
            mySubsequentDuration: me.mySubsequentDuration,
            mySubsequentDurationWithPadding: me.mySubsequentDurationWithPadding,
            subsequentServicesSelf: me.subsequentServicesSelf,
            nonSubsequentServicesSelf: me.nonSubsequentServicesSelf
          }
        };

        me.model.update(upObj);
      });
    }

    if (!site.client.isMobile && this.servicesData.length > 1) {
      apptBook.equalHeights(this.servContainer.find('.service-head'));
    }
  };

  apptBook.AppointmentSelectSection.prototype.buildLocation = function () {
    var me = this;

    this.locSelect.find('option').remove();
    this.stores = {};
    for (var i = 0, len = this.countersData.length; i < len; i += 1) {
      var storeName = this.countersData[i].name,
        optionText = this.countersData[i].town + ' - ' + storeName,
        optionValue = this.countersData[i].id,
        newOption = $('<option value="' + optionValue + '">' + optionText + '</option>'),
        storeNum = this.countersData[i].store_no,
        maxApptDuration = this.countersData[i].max_appointment_duration,
        tSlotInt =
          $('.appointment-select .col-heads').data('time-interval') ||
          $('.appt-book-datepicker-overlay .day').data('time-interval') ||
          this.countersData[i].timeslot_interval;

      // Use the timeslot interval from the selected counter
      if (this.counterId == this.countersData[i].id) {
        this.slotInterval = tSlotInt;
      }
      me.stores[optionValue] = {
        store: storeNum,
        name: storeName,
        maxApptDuration: maxApptDuration,
        tSlotInt: tSlotInt
      };

      if (optionValue === this.counterId) {
        newOption.attr('selected', 'selected');
      }
      this.locSelect.append(newOption);
      /* if (this.countersData[i].service_ids.length > 0 && this.countersData[i].calendars.length > 0) {
        this.locSelect.append(newOption);
      }*/
    }

    sortLocationOptions();

    function sortLocationOptions() {
      $(me.locSelect).html(
        $(me.locSelect)
          .find('option')
          .sort(function (a, b) {
            return a.text.toUpperCase() > b.text.toUpperCase()
              ? 1
              : a.text.toUpperCase() < b.text.toUpperCase()
              ? -1
              : 0;
          })
      );
    }
    me.locSelect.val(this.counterId); // need to reset the cached select value after a sort
    me.container.find('.selectbox').each(function () {
      var control = $(this).data('selectBox-control');

      if (control && control.length && !site.client.isMobile) {
        $(this).selectBox('refresh');
      }
    });

    function onLocChange(e) {
      var counterId = this.value,
        upObj = {};

      if (counterId !== me.counterId) {
        me.model.getCounter(counterId, { service_id: me.serviceIds }, function (data) {
          if (!data) {
            return;
          } else if (
            parseInt(data.max_appointment_duration) != 0 &&
            parseInt(data.max_appointment_duration) < me.totalTime
          ) {
            me.locSelect.val(me.counterId);
            me.launchLocationConflictOverlay(data.max_appointment_duration);

            return;
          } else {
            upObj = {
              sectionId: 'appointments',
              params: {
                counterId: counterId,
                services: me.servicesData,
                slotInterval: data.timeslot_interval,
                // slotInterval : me.stores[counterId]['tSlotInt'],
                appointmentDuration: me.totalTime,
                updateMode: me.updateMode
              }
            };
            me.model.update(upObj);
            site.track.evtLink({
              event_name: 'appointmentBooking_reselectLocation',
              event_category: 'appointment booking',
              event_action: 'reselect location',
              event_label: me.stores[counterId].store + ' - ' + me.stores[counterId].name
            });
          }
        });
      }
    }
    this.locSelect.off('change'); // remove this first just in case we have already been to this screen
    this.locSelect.on('change', onLocChange);
  };

  apptBook.AppointmentSelectSection.prototype.buildArtists = function () {
    var me = this,
      calData = this.counterData.calendars;

    // this.artContainer.css('display','block');
    this.artContainer.show();
    this.artSelect.find('option').remove();
    var hasSubsequent = 0;

    // TODO: Not sure if this will work correctly, I need to test this once I have everything else working
    // As is this will hide the artist selection IF the customer has /added/ a subsequent service. We may want to hide it in
    // the more general case that the counter has any calendars at all with subsequent services (?)
    for (var i = 0; i < this.servicesData.length; i++) {
      if (this.servicesData[i].subsequent == 1) {
        hasSubsequent = 1;
      }
    }
    if (!calData || !calData.length) {
      this.launchSelErrOverlay();
      // this.artContainer.css('display','none');
      this.artContainer.hide();
    } else if (calData.length <= 1 || hasSubsequent) {
      this.artContainer.hide();
    } else {
      for (var i = 0, len = calData.length; i < len; i += 1) {
        var optionText = calData[i].public_name,
          optionValue = calData[i].id,
          optionDisplay =
            typeof calData[i].artist_selectable_online !== 'undefined'
              ? parseInt(calData[i].artist_selectable_online)
              : 1,
          isChairMode =
            typeof calData[i].chair_mode !== 'undefined' ? parseInt(calData[i].chair_mode) : 1,
          newOption;

        if (optionDisplay && !isChairMode) {
          newOption = $('<option value="' + optionValue + '">' + optionText + '</option>');

          if (optionValue === this.calendarId) {
            newOption.attr('selected', 'selected');
          }

          this.artSelect.append(newOption);
        }
      }

      var artSelectLength = this.artSelect.find('option');

      if (artSelectLength.length <= 1) {
        this.artContainer.hide();
      }

      me.container.find('.selectbox').each(function () {
        var control = $(this).data('selectBox-control');

        if (control && control.length && !site.client.isMobile) {
          $(this).selectBox('refresh');
        }
      });
    }
  };

  apptBook.AppointmentSelectSection.prototype.buildApptSelect = function () {
    var mOptions,
      vOptions,
      dpOptions,
      calDate,
      calTable,
      calHead,
      cHCont,
      colHeads,
      timeSlotsContainer,
      timeSlotRow,
      slotLabels,
      dpTrigger,
      dpField,
      dpOverlay,
      dpCalCont,
      dpCloseBtn,
      dp,
      dpDayNames,
      CalHeadView,
      CalTimeSlotsView,
      CalDatePicker,
      totText,
      closedCopy,
      me = this;
    // var calendarContainer = this.apptContainer.find('.calendar');
    var bookBtn = this.bookBar.find('#appt-book-book-submit').off('click');

    if (site.client.isMobile) {
      dpOverlay = this.container.find('#appt-book-datepicker-overlay').prependTo(this.jqBod);
      timeSlotsContainer = dpOverlay.find('table.day'); // replace parent
      timeSlotRow = timeSlotsContainer.find('tr').remove().first();
      if (
        document.documentElement.dir === 'rtl' &&
        this.container.find('.weekdays').hasClass('calendar-view')
      ) {
        timeSlotRow.children().each(function (i, th) {
          timeSlotRow.prepend(th);
        });
      }
      slotLabels = timeSlotsContainer.attr('data-time-slots').split(',');
      closedCopy = timeSlotsContainer.attr('data-closed-copy') || 'closed';
      calHead = this.apptContainer.find('.calendar-head');
      dpTrigger = calHead.find('#appt-book-date-picker-trigger');
      dp = dpOverlay.find('.date-picker'); // replace parent
      dpField = dpOverlay.find('#appt-book-date-picker-field'); // replace parent
      dpCont = dpOverlay.find('.date-picker-container'); // replace parent
      dpCalCont = dpOverlay.find('#appt-book-datepicker-calendar-container'); // replace parent
      dpCloseBtn = dpCont.find('.date-picker-close');
      CalHeadView = apptBook.CalendarHeaderMobile;
      CalTimeSlotsView = apptBook.CalendarTimeSlotsMobile;
      CalDatePicker = apptBook.CalDatePickerMobile;
      dpOverlay.remove();

      vOptions = {
        container: this.apptContainer,
        interval: this.slotInterval,
        timeSlotsContainer: timeSlotsContainer,
        timeSlotRow: timeSlotRow,
        slotLabels: slotLabels,
        closedCopy: closedCopy,
        calDayOfWeekFormat: this.calDayOfWeekFormat
      };

      dpOptions = {
        overlay: dpOverlay,
        container: dpCont,
        closeBtn: dpCloseBtn,
        calContainer: dpCalCont,
        datepickerField: dpField,
        datepickerTrigger: dpTrigger,
        jqBod: this.jqBod
      };
    } else {
      calTable = this.apptContainer.find('.weekdays');
      calHead = this.apptContainer.find('.calendar-head');
      cHCont = calTable.find('thead.col-heads');
      colHeads = cHCont.find('th');
      timeSlotsContainer = calTable.find('tbody.timeslots');
      timeSlotRow = timeSlotsContainer.find('tr').remove().first();
      if (
        document.documentElement.dir === 'rtl' &&
        this.container.find('.weekdays').hasClass('calendar-view')
      ) {
        timeSlotRow.children().each(function (i, th) {
          timeSlotRow.prepend(th);
        });
      }
      slotLabels = cHCont.attr('data-time-slots').split(',');
      closedCopy = cHCont.attr('data-closed-copy') || 'closed';
      dpTrigger = calHead.find('#appt-book-date-picker-trigger');
      dpField = calHead.find('#appt-book-date-picker-field');
      dpOverlay = this.container.find('#appt-book-datepicker-overlay').remove();
      dpCalCont = dpOverlay.find('#appt-book-datepicker-calendar-container');
      dpCloseBtn = dpOverlay.find('.overlay-close');
      CalHeadView = apptBook.CalendarHeader;
      CalTimeSlotsView = apptBook.CalendarTimeSlots;
      CalDatePicker = apptBook.CalDatePicker;

      vOptions = {
        container: this.apptContainer,
        interval: this.slotInterval,
        colHeads: colHeads,
        timeSlotsContainer: timeSlotsContainer,
        timeSlotRow: timeSlotRow,
        slotLabels: slotLabels,
        closedCopy: closedCopy,
        calDayOfWeekFormat: this.calDayOfWeekFormat
      };

      dpOptions = {
        overlay: dpOverlay,
        closeBtn: dpCloseBtn,
        calContainer: dpCalCont,
        weekContainer: calHead,
        datepickerField: dpField,
        datepickerTrigger: dpTrigger,
        jqBod: calHead
      };
    }

    mOptions = {
      dataModel: this.model,
      launchOverlayCallback: this.launchSelErrOverlay.bind(this),
      datepickerContainer: dpCalCont,
      counterId: this.counterId,
      appointmentDuration: this.apptDur,
      appointmentDurationWithPadding: this.totalTimeWithPadding,
      timeSlotsContainer: timeSlotsContainer,
      appointmentPrice: this.totalPrice,
      serviceIds: this.serviceIds,
      myNonSubsequentDuration: this.myNonSubsequentDuration,
      myNonSubsequentDurationWithPadding: this.myNonSubsequentDurationWithPadding,
      mySubsequentDuration: this.mySubsequentDuration,
      mySubsequentDurationWithPadding: this.mySubsequentDurationWithPadding,
      subsequentServicesSelf: this.subsequentServicesSelf,
      nonSubsequentServicesSelf: this.nonSubsequentServicesSelf
    };

    this.calModel = new apptBook.CalendarModel();
    this.calModel.setData(mOptions);
    this.calTimeSlots = new CalTimeSlotsView(vOptions);
    this.calHeadView = new CalHeadView(calHead);
    this.calTimeSlots.setModel(this.calModel).startObserving();
    this.calHeadView.setModel(this.calModel).startObserving();

    this.datePicker = new CalDatePicker(dpOptions);
    this.datePicker.setModel(this.calModel);

    this.artSelect.on('change', function (e) {
      var calId = this.value,
        calName = this.options[this.selectedIndex].text;

      if (calId !== me.calendarId) {
        me.calModel.update({
          calendarId: calId,
          apptDur: me.apptDur
        });
        me.calendarId = calId;
      }
    });

    calDate = this.appointmentTime ? dateUtils.convertTimeString(this.appointmentTime) : new Date();
    var openTimes = me.counterData.opening_time_range;

    this.calModel.update({
      date: calDate,
      hilite: true,
      calendarId: this.calendarId,
      apptDur: this.apptDur,
      appointmentTime: this.appointmentTime,
      openTimes: openTimes,
      showNextWeek: true
    });

    totText = this.totalText + ' ' + this.totalTime + ' ' + this.minLabel;
    this.totalElem.html(totText);

    this.startOver.off('click');
    this.startOver.click(function () {});

    this.calModel.on('time_selected', function (data) {
      bookBtn.removeClass('disabled').removeAttr('tabindex');
      dpCloseBtn.trigger('click');
    });

    this.calModel.on('time_deselected', function (data) {
      bookBtn.addClass('disabled').attr('tabindex', '-1');
    });

    bookBtn.click(onSubmitBooking);

    function onSubmitBooking(e) {
      e.preventDefault();
      var params = {},
        updateData,
        $this = $(this),
        isArray = me.serviceIds instanceof Array;

      if ($this.hasClass('disabled')) {
        return;
      }

      $this.addClass('disabled');

      params = {
        counterId: me.counterId,
        calendarId: me.calendarId,
        serviceIds: me.serviceIds,
        services: me.servicesData,
        appointmentId: me.appointmentId,
        startTime: me.calModel.getSelection().selectionString,
        myNonSubsequentDuration: me.myNonSubsequentDuration,
        myNonSubsequentDurationWithPadding: me.myNonSubsequentDurationWithPadding,
        mySubsequentDuration: me.mySubsequentDuration,
        mySubsequentDurationWithPadding: me.mySubsequentDurationWithPadding,
        subsequentServicesSelf: me.subsequentServicesSelf,
        nonSubsequentServicesSelf: me.nonSubsequentServicesSelf
      };

      site.track.evtLink({
        event_name: 'appointmentBooking_DateTime',
        event_category: 'appointment booking',
        event_action: 'Date and Time Picked',
        event_label:
          me.counterData.store_no + ' - ' + me.counterData.name + ' - ' + params.startTime
      });

      updateData = {
        sectionId: 'next',
        params: params
      };

      function onBookSuccess(r) {
        var updateData,
          apptId = r.id;

        updateData = {
          sectionId: 'next',
          params: r
        };
        me.model.update(updateData);
        $this.addClass('disabled');
      }

      function onBookError(r) {
        $this.removeClass('disabled');

        if (r.code === 500 || r.code === '500') {
          me.launchBookConflictOverlay();

          return;
        }
      }

      function doBooking() {
        // if (me.updateMode && me.appointmentId) {
        // me.model.changeAppointment(me.appointmentId, params, onBookSuccess, onBookError);
        // } else {
        me.model.update(updateData);
        $this.addClass('disabled');
        // }
      }

      doBooking();
    }
  };

  apptBook.AppointmentSelectSection.prototype.launchSelErrOverlay = function () {
    var errKey = 'invalid_services';

    apptBook.showErrorDialog(errKey);
    //
    // this update previously fired on click when closing the err dialog
    // let's try firing it in the background instead
    var upObj = {
      sectionId: 'services',
      params: {
        sectionId: this.id,
        counterId: this.counterId,
        updateMode: this.updateMode
      }
    };

    this.model.update(upObj);
  };

  // appt-book-book-conflict-overlay
  // book_conflict_overlay_content
  apptBook.AppointmentSelectSection.prototype.launchBookConflictOverlay = function () {
    var selDate = this.calModel.getSelection().selectionDate;

    this.calModel.update({ date: selDate });
    var errKey = 'book_conflict';

    apptBook.showErrorDialog(errKey);
  };

  apptBook.AppointmentSelectSection.prototype.removeService = function (service) {
    var me = this;
    var serviceContainer = service.hasClass('service') ? service : service.parents('.service'),
      // servicesContainer = serviceContainer.parents('.services'),
      serviceId = serviceContainer.attr('data-service-id'),
      upObj = {};

    me.totalTime = 0;
    me.serviceIds = jQuery.grep(me.serviceIds, function (value) {
      return value != serviceId;
    });
    me.servicesData = jQuery.grep(me.servicesData, function (service) {
      if (service.serviceId != serviceId) {
        me.totalTime += service.serviceDuration;
      }

      return service.serviceId != serviceId;
    });

    serviceContainer.remove();

    if (me.totalTime == 0) {
      upObj = {
        sectionId: 'services',
        params: {
          sectionId: me.id,
          counterId: me.counterId,
          serviceIds: me.serviceIds,
          updateMode: me.updateMode,
          myNonSubsequentDuration: me.myNonSubsequentDuration,
          myNonSubsequentDurationWithPadding: me.myNonSubsequentDurationWithPadding,
          mySubsequentDuration: me.mySubsequentDuration,
          mySubsequentDurationWithPadding: me.mySubsequentDurationWithPadding,
          subsequentServicesSelf: me.subsequentServicesSelf,
          nonSubsequentServicesSelf: me.nonSubsequentServicesSelf,
          dateSet: false
        }
      };
    } else {
      upObj = {
        sectionId: 'appointments',
        params: {
          counterId: me.counterId,
          services: me.servicesData,
          slotInterval: me.slotInterval,
          appointmentDuration: me.totalTime,
          updateMode: me.updateMode,
          myNonSubsequentDuration: me.myNonSubsequentDuration,
          myNonSubsequentDurationWithPadding: me.myNonSubsequentDurationWithPadding,
          mySubsequentDuration: me.mySubsequentDuration,
          mySubsequentDurationWithPadding: me.mySubsequentDurationWithPadding,
          subsequentServicesSelf: me.subsequentServicesSelf,
          nonSubsequentServicesSelf: me.nonSubsequentServicesSelf,
          dateSet: false
        }
      };
    }
    me.model.update(upObj);
  };

  apptBook.AppointmentSelectSection.prototype.launchLocationConflictOverlay = function (
    maxDuration
  ) {
    console.log('launchLocationConflictOverlay');
    var me = this;

    this.jqBod.prepend(this.locationConflictOverlay);
    me.locationConflictOverlay.find('span.max_duration').text(maxDuration);
    this.locationConflictOverlay.show();
    this.locationConflictOverlay.click(function (e) {
      e.preventDefault();
      me.locationConflictOverlay.off('click');
      me.locationConflictOverlay.remove();
    });
  };

  /* *
   *
   * Appointments Time Slot Selector Calendar and Mobile Calendar
   * This is a set of Classes that create objects that are the members of an MVC Calendar that displays and allows
   * selection of the available time slots of calendars coming from the API.
   *
   *
   *
   * */

  /**
   * CalendarModel
   * This is the model. It controls the calendars state and main logic.
   * It broadcasts updates to registered views and controllers
   *
   */

  apptBook.CalendarModel = function () {
    apptBook.CalendarModel.superclass.constructor.call(this);
    this.dataSet = false;
    this.dateSet = false;
    this.isDateSelected = false;
    this.container = $('body').find('#appointment-book-container');
    this.winPos = $(window).scrollTop();
  };

  // CalendarModel is a Publisher in a Publisher Subscriber (event listening) pattern.
  ctrlopt.extend(apptBook.CalendarModel, ctrlopt.Publisher);

  apptBook.CalendarModel.prototype.setData = function (options) {
    if (this.dataSet) {
      return;
    }
    this.dataSet = true;
    this.calData = {};
    this.dataModel = options.dataModel;
    this.launchOverlay = options.launchOverlayCallback;
    this.datepickerContainer = options.datepickerContainer;
    this.timeSlotsContainer = options.timeSlotsContainer;
    this.counterId = options.counterId;
    this.calendarId = 0;
    this.apptDur = options.appointmentDuration;
    this.apptDurWithPadding = options.appointmentDurationWithPadding;
    this.serviceIds = options.serviceIds;
    this.myNonSubsequentDuration = options.myNonSubsequentDuration;
    this.myNonSubsequentDurationWithPadding = options.myNonSubsequentDurationWithPadding;
    this.mySubsequentDuration = options.mySubsequentDuration;
    this.mySubsequentDurationWithPadding = options.mySubsequentDurationWithPadding;
    this.subsequentServicesSelf = options.subsequentServicesSelf;
    this.nonSubsequentServicesSelf = options.nonSubsequentServicesSelf;
  };

  apptBook.CalendarModel.prototype.update = function (data) {
    if (!this.dataSet || !data) {
      return;
    }
    var me = this;

    this.calData.hilite = data.hilite ? true : false;
    this.calData.apptDur = data.apptDur;
    this.calData.apptDurWithPadding = this.apptDurWithPadding;
    this.calData.currentDate = this.calData.currentDate || new Date();
    this.calData.myDate = data.date || this.calData.myDate || this.calData.currentDate;
    this.calData.showNextWeek = true;
    this.calendarId = data.calendarId || this.calendarId;
    this.counterId = data.counterId || this.counterId;
    this.serviceIds = data.serviceIds || this.serviceIds;
    this.calData.apptTime = data.appointmentTime;
    this.calData.openTimes = data.openTimes || this.calData.openTimes;
    this.calData.datesInvalid = data.datesInvalid || this.calData.datesInvalid || [];
    this.subsequentServicesSelf =
      typeof data.subsequentServicesSelf !== 'undefined'
        ? data.subsequentServicesSelf
        : this.subsequentServicesSelf;
    this.nonSubsequentServicesSelf =
      typeof data.nonSubsequentServicesSelf !== 'undefined'
        ? data.nonSubsequentServicesSelf
        : this.nonSubsequentServicesSelf;
    this.myNonSubsequentDuration =
      typeof data.myNonSubsequentDuration !== 'undefined'
        ? data.myNonSubsequentDuration
        : this.myNonSubsequentDuration;
    this.myNonSubsequentDurationWithPadding =
      typeof data.myNonSubsequentDurationWithPadding !== 'undefined'
        ? data.myNonSubsequentDurationWithPadding
        : this.myNonSubsequentDurationWithPadding;
    this.mySubsequentDuration =
      typeof data.mySubsequentDuration !== 'undefined'
        ? data.mySubsequentDuration
        : this.mySubsequentDuration;
    this.mySubsequentDurationWithPadding =
      typeof data.mySubsequentDurationWithPadding !== 'undefined'
        ? data.mySubsequentDurationWithPadding
        : this.mySubsequentDurationWithPadding;
    if (typeof data.timeSlotInterval != 'undefined') {
      this.calData.timeSlotInterval = data.timeSlotInterval;
    }
    if (typeof data.dateSet != 'undefined') {
      this.dateSet = data.dateSet;
    }

    // If these are not set, we came from an Edit link for an existing appointment, which is nonSubsequent. Use those.
    if (
      this.subsequentServicesSelf.length == 0 &&
      this.nonSubsequentServicesSelf.length == 0 &&
      this.serviceIds.length > 0
    ) {
      this.nonSubsequentServicesSelf = this.serviceIds;
    }

    // Intersect the timeslots of 2 given input calendars. Return a calendar containing only slots where BOTH
    // passed calendars have availability. Expects params calendarOne and calendarTwo
    // NOTE: I left in the support in here for side-by-side, even though it is unused on Mac
    function intersectCalendars(params) {
      var cal1 = params.calendarOne;
      var cal2 = params.calendarTwo;
      var cal1slots, cal2slots, cal1arrayindex;

      for (var i = 0, len = cal1.length; i < len; i += 1) {
        cal = cal1[i];
        if (parseInt(cal.id, 10) === parseInt(me.calendarId, 10)) {
          cal1slots = cal1[i].timeslots;
          cal1arrayindex = i;
          break;
        }
      }
      for (var i = 0, len = cal2.length; i < len; i += 1) {
        cal = cal2[i];
        if (parseInt(cal.id, 10) === parseInt(me.calendarId, 10)) {
          cal2slots = cal2[i].timeslots;
          break;
        }
      }
      var intSlots = []; // We will use this to store the intersected timeslots, which we will replace on cal1 and return cal1 when complete

      for (var i = 0, len = cal1slots.length; i < len; i += 1) {
        var ts1 = cal1slots[i];
        var ts1StartEpoch = dateUtils.convertTimeString(ts1.start_date).valueOf();
        var ts1EndEpoch = dateUtils.convertTimeString(ts1.end_date).valueOf();

        for (var j = 0, len2 = cal2slots.length; j < len2; j += 1) {
          var ts2 = cal2slots[j];
          var ts2StartEpoch = dateUtils.convertTimeString(ts2.start_date).valueOf();
          var ts2EndEpoch = dateUtils.convertTimeString(ts2.end_date).valueOf();
          var interSlot = new Object();

          // a) cal2 timeslot completely encompasses cal1 timeslot (bigger than cal1 OR equal to it): Keep cal1 timeslot unmodified
          // cal1:        |---------------------|
          // cal2:    |------------------------------|
          // res:         |---------------------|
          if (ts2StartEpoch <= ts1StartEpoch && ts2EndEpoch >= ts1EndEpoch) {
            interSlot.StartEpoch = ts1StartEpoch;
            interSlot.EndEpoch = ts1EndEpoch;
            intSlots.push(interSlot);
            break;

            // b) cal2 timeslot is completely encompassed by (smaller than) cal1 timeslot: Add cal2 timeslot, keep looking for  other overlaps
            // cal1:    |------------------------------|
            // cal2:        |-------|
            // res:         |-------|
          } else if (ts1StartEpoch <= ts2StartEpoch && ts1EndEpoch >= ts2EndEpoch) {
            interSlot.StartEpoch = ts2StartEpoch;
            interSlot.EndEpoch = ts2EndEpoch;
            intSlots.push(interSlot);

            // c) cal2 timeslot overlaps the start, but not the end time of cal1 timeslot: Add timeslot with start of cal1 and end of cal2
            // cal1:       |--------------------------|
            // cal2:  |-------------|
            // res:        |--------|
          } else if (
            ts2StartEpoch < ts1StartEpoch &&
            ts2EndEpoch > ts1StartEpoch &&
            ts2EndEpoch < ts1EndEpoch
          ) {
            interSlot.EndEpoch = ts2EndEpoch;
            interSlot.StartEpoch = ts1StartEpoch;
            intSlots.push(interSlot);

            // d) cal2 timeslot overlaps the end, but not the start of cal1 timeaslot: Add timeslot with start of ca2 and end of cal1
            // cal1:       |-----------------------------|
            // cal2:                         |-------------------|
            // res:                          |-----------|
          } else if (
            ts2StartEpoch > ts1StartEpoch &&
            ts2StartEpoch < ts1EndEpoch &&
            ts2EndEpoch > ts1EndEpoch
          ) {
            interSlot.StartEpoch = ts2StartEpoch;
            interSlot.EndEpoch = ts1EndEpoch;
            intSlots.push(interSlot);
          }
        }
      }
      var intSlotsHumanReadable = [];

      // Take a number and a length (in characters) to pad that number out to. Return it with prepended zeroes to pad
      // Expects params: number, padLength
      function padNum(params) {
        var s = params.number + '';

        while (s.length < params.padLength) {
          s = '0' + s;
        }

        return s;
      }
      function epochToDate(unixEpoch) {
        var uDate = new Date(unixEpoch);

        return (
          uDate.getYear() +
          1900 +
          '-' +
          padNum({
            number: uDate.getMonth() + 1,
            padLength: 2
          }) +
          '-' +
          padNum({
            number: uDate.getDate(),
            padLength: 2
          }) +
          ' ' +
          padNum({
            number: uDate.getHours(),
            padLength: 2
          }) +
          ':' +
          padNum({
            number: uDate.getMinutes(),
            padLength: 2
          }) +
          ':' +
          padNum({
            number: uDate.getSeconds(),
            padLength: 2
          })
        );
      }
      for (var i = 0, len = intSlots.length; i < len; i += 1) {
        intSlot = intSlots[i];
        var intSlotReadable = new Object();

        intSlotReadable.end_date = epochToDate(intSlot.EndEpoch);
        intSlotReadable.start_date = epochToDate(intSlot.StartEpoch);
        intSlotsHumanReadable.push(intSlotReadable);
      }
      // replace cal1 timeslots with our new ones
      cal1[cal1arrayindex].timeslots = intSlotsHumanReadable;

      return cal1;
    }

    // Initial invalidation of timeslots where there won't be enough room at the end of the slot to book the appointment
    // Expects params: calendarOne, calendarTwo
    function setupTimeSlots(params) {
      var cals = params.calendarOne;
      var secondCal = params.calendarTwo;

      if (!cals || !cals.length) {
        me.calData.timeslots = null;
        if (me.launchOverlay && typeof me.launchOverlay === 'function') {
          me.launchOverlay();
        }
      } else {
        for (var i = 0, len = cals.length; i < len; i += 1) {
          cal = cals[i];
          if (parseInt(cal.id, 10) === parseInt(me.calendarId, 10)) {
            me.calData.timeslots = cal.timeslots;
            break;
          }
        }

        // Set some data for use by processSlot() to account for subsequent
        if (secondCal) {
          me.calData.secondTimeSlots = secondCal[0].timeslots;
        }
        me.calData.myNonSubsequentDuration = me.myNonSubsequentDuration || 0;
        me.calData.myNonSubsequentDurationWithPadding = me.myNonSubsequentDurationWithPadding || 0;
        me.calData.mySubsequentDuration = me.mySubsequentDuration || 0;
        me.calData.mySubsequentDurationWithPadding = me.mySubsequentDurationWithPadding || 0;
        me.calData.friendNonSubsequentDuration = me.friendNonSubsequentDuration || 0;
        me.calData.friendSubsequentDuration = me.friendSubsequentDuration || 0;

        // Get the invalid Dates with range times less than the Appt Duration
        for (var i = 0, len = me.calData.timeslots.length; i < len; i += 1) {
          var range = me.calData.timeslots[i],
            start = dateUtils.convertTimeString(range.start_date),
            end = dateUtils.convertTimeString(range.end_date);

          timeLeft = end.getTime() - start.getTime();
          minLeft = Math.floor(timeLeft / 60000);
          dateKey = dateUtils.dateToString(start, 'yyyy-mm-dd');
          // We should use the LONGER of either your service duration or your friends (if we have both types), this is a little simplistic
          // and will end up being a bit conservative about the available timeslots displayed, but it should work
          var biggestApptDuration =
            me.calData.myNonSubsequentDurationWithPadding > me.calData.friendNonSubsequentDuration
              ? me.calData.myNonSubsequentDurationWithPadding
              : me.calData.friendNonSubsequentDuration;

          if (minLeft < biggestApptDuration) {
            if ($.inArray(dateKey, me.calData.datesInvalid) == -1) {
              me.calData.datesInvalid.push(dateKey);
            }
          } else {
            me.calData.datesInvalid = $.grep(me.calData.datesInvalid, function (value) {
              return value != dateKey;
            });
          }
        }
      }
      if (!me.dateSet) {
        me.fire('time_deselected');
      }
      me.dispatchUpdate(me.calData);
    }

    var totalCalsToProcess = 0,
      calsProcessed = 0;
    var nonSubCalSelf, subCalSelf, nonSubCalFriend, subCalFriend;

    // This function is called as the callback when getSlotsForAppointment successfully finishes its call to
    // getCounter(). It can be called up to 4 times or as little as once, depending on the services
    // selected (eg, side-by-side and/or subsequent).
    // This does all the work to combine the various calendars timeslots and at the end, call setupTimeSlots()
    // Expects params: calendars, apptType
    this.preProcessSlots = function preProcessSlots(params) {
      var calendars = params.calendars;
      var apptType = params.apptType;

      calsProcessed += 1;
      switch (apptType) {
        case 'nonSubsequentSelf':
          nonSubCalSelf = calendars;
          break;
        case 'subsequentSelf':
          subCalSelf = calendars;
          break;
        case 'nonSubsequentFriend':
          nonSubCalFriend = calendars;
          break;
        case 'subsequentFriend':
          subCalFriend = calendars;
          break;
      }
      if (calsProcessed == totalCalsToProcess) {
        // Now we have all the calendars. Let's combine them for the final sets to be used
        // This is the complicated part :)
        // For what we pass to setupTimeSlots we just need to intersect the availability of the
        // chronological first self and friend calendars (or just directly use one or the other
        // if we don't have both).
        // Whatever is leftover is the subsequent that we will need to check against when processing the timeslots
        // Get the calendars for the FIRST set of services chronologically, intersected with the
        // one for your friend if it exists.
        var firstCalSelf, firstCalFriend;
        var secondCalSelf, secondCalFriend;

        if (nonSubCalSelf) {
          firstCalSelf = nonSubCalSelf;
          secondCalSelf = subCalSelf;
        } else if (subCalSelf) {
          firstCalSelf = subCalSelf;
        }

        if (nonSubCalFriend) {
          firstCalFriend = nonSubCalFriend;
          secondCalFriend = subCalFriend;
        } else if (subCalFriend) {
          firstCalFriend = subCalFriend;
        }

        var firstCal, secondCal;

        if (firstCalSelf && firstCalFriend) {
          firstCal = intersectCalendars({
            calendarOne: firstCalSelf,
            calendarTwo: firstCalFriend
          });
        } else if (firstCalSelf) {
          firstCal = firstCalSelf;
        } else {
          firstCal = firstCalFriend;
        }

        if (secondCalSelf && secondCalFriend) {
          secondCal = intersectCalendars({
            calendarOne: secondCalSelf,
            calendarTwo: secondCalFriend
          });
        } else if (secondCalSelf) {
          secondCal = secondCalSelf;
        } else {
          secondCal = secondCalFriend;
        }

        setupTimeSlots({
          calendarOne: firstCal,
          calendarTwo: secondCal
        });
      }
    };

    // Called once for each selected type of 4 different possible services:
    // 1 - Non subsequent services for self
    // 2 - Subsequent services for self
    // 3 - Non subsequent services for friend
    // 4 - Subsequent services for friend
    // This will get counter timeslots for each set of selected services and then call preProcessSlots() in order to combine
    // all returned sets of slots
    // Expects params: counterId, serviceIds, apptType, concurrent
    this.getSlotsForAppointment = function (params) {
      this.getCounterCallback = function (apptType, countData) {
        var cals = countData.calendars;

        this.preProcessSlots({
          calendars: cals,
          apptType: apptType
        });
      };
      getCounterArgs = { service_id: params.serviceIds };
      if (params.concurrent) {
        getCounterArgs['any_min_concurrent'] = 2;
      }
      this.dataModel.getCounter(
        params.counterId,
        getCounterArgs,
        $.proxy(this.getCounterCallback, this, params.apptType)
      );
    };
    // Sort service arrays for easy equality comparison below:
    // MAC does not have book with a friend, so just hardcode the friendservices to []
    this.nonSubsequentServicesSelf = this.nonSubsequentServicesSelf.sort();
    //    this.nonSubsequentServicesFriend = this.nonSubsequentServicesFriend.sort();
    this.nonSubsequentServicesFriend = [];
    this.subsequentServicesSelf = this.subsequentServicesSelf.sort();
    //    this.subsequentServicesFriend = this.subsequentServicesFriend.sort();
    this.subsequentServicesFriend = [];

    if (this.nonSubsequentServicesSelf.length > 0) {
      totalCalsToProcess += 1;
      this.getSlotsForAppointment({
        counterId: this.counterId,
        serviceIds: this.nonSubsequentServicesSelf,
        apptType: 'nonSubsequentSelf',
        concurrent: this.nonSubsequentServicesFriend.length > 0
      });
    }

    // If the services for your friend are the same as yourself, then the previous call with any_min_concurrent will cover this
    if (
      this.nonSubsequentServicesFriend.length > 0 &&
      this.nonSubsequentServicesFriend.toString() != this.nonSubsequentServicesSelf.toString()
    ) {
      totalCalsToProcess += 1;
      this.getSlotsForAppointment({
        counterId: this.counterId,
        serviceIds: this.nonSubsequentServicesFriend,
        apptType: 'nonSubsequentFriend',
        concurrent: this.nonSubsequentServicesSelf.length > 0
      });
    }

    if (this.subsequentServicesSelf.length > 0) {
      totalCalsToProcess += 1;
      this.getSlotsForAppointment({
        counterId: this.counterId,
        serviceIds: this.subsequentServicesSelf,
        apptType: 'subsequentSelf',
        concurrent: this.subsequentServicesFriend.length > 0
      });
    }

    // If the services for your friend are the same as yourself, then the previous call with any_min_concurrent will cover this
    if (
      this.subsequentServicesFriend.length > 0 &&
      this.subsequentServicesSelf.toString() != this.subsequentServicesFriend.toString()
    ) {
      totalCalsToProcess += 1;
      this.getSlotsForAppointment({
        counterId: this.counterId,
        serviceIds: this.subsequentServicesFriend,
        apptType: 'subsequentFriend',
        concurrent: this.subsequentServicesSelf.length > 0
      });
    }
  };

  apptBook.CalendarModel.prototype.dispatchUpdate = function (data) {
    this.fire('update', data);
  };

  apptBook.CalendarModel.prototype.getData = function () {
    return this.dataSet ? this.calData : null;
  };

  apptBook.CalendarModel.prototype.setSelection = function (selection, me) {
    this.selection = selection;
    this.selectionString =
      selection.getFullYear() +
      '-' +
      (selection.getMonth() + 1).toString().padStart(2, '0') +
      '-' +
      selection.getDate().toString().padStart(2, '0') +
      ' ' +
      selection.getHours().toString().padStart(2, '0') +
      ':' +
      ('0' + selection.getMinutes()).slice(-2) +
      ':00';
    var dayNumber = startDayShift(this.selection.getDay());

    // Test
    if (site.client.isMobile) {
      if (me.model) {
        $(window).scrollTop(me.model.winPos);
        me.model.headContent.removeClass('hidden');
        me.model.hDefContent.addClass('hidden');
        me.model.update({
          date: selection,
          hilite: true,
          apptDur: me.model.apptDur
        });
        me.model.dateSet = true;
      }
    } else {
      var colHeads = $('thead.col-heads');

      colHeads
        .find('th')
        .removeClass('hilite')
        .filter('.day-' + dayNumber)
        .addClass('hilite');
    }
    this.fire('time_selected', this.selectionString);
  };

  apptBook.CalendarModel.prototype.getSelection = function () {
    return {
      selectionDate: this.selection,
      selectionString: this.selectionString
    };
  };

  /**
   * CalendarHeader is a class for concrete views of the CalendarModel.
   * It displays and manages the display logic for the Desktop Time Slot Calendar Header.
   *
   *
   * @param header JQuery required    a jquery object that contains a DOM element that represents the root element of the
   *                                  header.
   *
   *
   * @constructor
   */

  apptBook.CalendarHeader = function (header) {
    apptBook.CalendarHeader.superclass.constructor.call(this);
    this.initialized = false;
    this.header = header;
    this.rArrow = this.header.find('.next');
    this.lArrow = this.header.find('.previous');
    this.dayStates = this.header.find('.day-time');
    this.morning = this.dayStates.find('.morning');
    this.afternoon = this.dayStates.find('.afternoon');
    this.evening = this.dayStates.find('.evening');
    this.headContent = this.header.find('.cal-copy');
    this.headDateFormat = this.header.attr('data-cal-week-select-date-format') || 'MMMM D';
    this.headCopy = this.headContent.html();
  };

  ctrlopt.extend(apptBook.CalendarHeader, ctrlopt.mvc.AbstractView);

  apptBook.CalendarHeader.prototype.defaultController = function () {
    return this.controller;
  };

  apptBook.CalendarHeader.prototype.onUpdate = function (data) {
    this.calData = data;
    var headOut,
      me = this,
      myDate = this.calData.myDate,
      dayOfWeek = startDayShift(myDate.getDay()),
      now = new Date(),
      nowDay = startDayShift(now.getDay());

    now.setDate(now.getDate() - nowDay);
    this.firstDay = new Date(myDate.getTime());
    this.firstDay.setDate(this.firstDay.getDate() - dayOfWeek);
    this.firstDay.setHours(0, 0, 0, 0);

    this.lastDay = new Date(this.firstDay.getTime());
    this.lastDay.setDate(this.lastDay.getDate() + 6);
    this.lastDay.setHours(23, 59, 59, 999);

    var findTimeSlotAvailableStatus = me.model.timeSlotsContainer
      .find('td')
      .filter('.enabled')
      .first();
    var findWrapperCalendar = me.model.timeSlotsContainer.closest('.weekdays');
    var slotCalendarView = findWrapperCalendar.hasClass('calendar-view');
    var verifyNoSlotAvailable = findWrapperCalendar.next('.js-calendar-wrapper-no-slot');
    var nextCalendarDate = new Date(me.firstDay.getTime());

    if (this.firstDay > now) {
      this.lArrow.css('visibility', 'visible');
    } else {
      this.lArrow.css('visibility', 'hidden');
    }

    // test if store is closed in morning/afternoon/evening on the selected day
    // fetch a hash of open states
    var openStates = this.getStoreOpenStates(this.calData.myDate, this.calData.openTimes);
    var OAB_start_last_date =
      Drupal.settings.globals_variables.OAB_show_start_last_date !== 'undefined'
        ? Drupal.settings.globals_variables.OAB_show_start_last_date
        : 0;

    for (var dayPart in openStates) {
      this[dayPart].removeClass('store_closed');
      this[dayPart].attr('tabindex', '0');
      if (!openStates[dayPart]) {
        // add css class if store is closed for that day part
        this[dayPart].addClass('store_closed');
        this[dayPart].attr('tabindex', '-1');
      }
    }

    // Moment adds '.' to the end of short month names for a lot of locales and we do not want it.
    var formattedDate = moment(this.firstDay).format(this.headDateFormat).replace('.', '');

    if (OAB_start_last_date) {
      formattedDate += ' - ' + moment(this.lastDay).format(this.headDateFormat).replace('.', '');
    }
    if (oab_show_head_copy_last) {
      headOut = formattedDate + ' ' + this.headCopy;
    } else {
      headOut = this.headCopy + ' ' + formattedDate;
    }

    this.headContent.html(headOut);

    this.lArrow.off('click');
    this.rArrow.off('click');
    this.morning.off('click');
    this.afternoon.off('click');
    this.evening.off('click');
    var keycode = '';

    this.rArrow.css('cursor', 'pointer').on('click keydown', function (e) {
      keycode = site.getKeycode(e);
      if (keycode === 13 || keycode === 1) {
        e.preventDefault();
        var nextDate = new Date(me.firstDay.getTime());

        nextDate.setDate(nextDate.getDate() + 7);
        me.model.isDateSelected = false;

        me.rArrow.css('cursor', 'default').off('click');
        me.lArrow.css('cursor', 'default').off('click');
        me.model.update({
          date: nextDate,
          apptDur: me.model.calData.apptDur
        });
        data.showNextWeek = false;
      }
    });
    // triggers next week selection by keydown

    this.lArrow.css('cursor', 'pointer').on('click keydown', function (e) {
      keycode = site.getKeycode(e);
      if (keycode === 13 || keycode === 1) {
        e.preventDefault();
        var prevDate = new Date(me.firstDay.getTime());

        prevDate.setDate(prevDate.getDate() - 7);
        me.model.isDateSelected = false;

        me.rArrow.css('cursor', 'default').off('click');
        me.lArrow.css('cursor', 'default').off('click');
        me.model.update({
          date: prevDate,
          apptDur: me.model.calData.apptDur
        });
        data.showNextWeek = false;
      }
    });

    this.scrollToTime = function (time, selector) {
      var $tCell = $("td[data-hour='" + time + "']");
      var $tRow = $tCell.parent();
      var scrollTarget = $('.weekdays .col-heads').height() + $tRow.height() * ($tRow.index() - 1);

      me.dayStates.find('.selected').removeClass('selected');
      selector.addClass('selected');
      $('tbody.timeslots').animate(
        {
          scrollTop: scrollTarget
        },
        1000
      );
    };

    if (!me.initialized) {
      this.scrollToTime('12:00', $(this.afternoon));
    }

    if (!!openStates.morning) {
      this.morning.css('cursor', 'pointer').click(function (e) {
        e.preventDefault();
        var date = new Date(me.firstDay.getTime());

        me.header.parent().attr('data-day-status', 'morning');
        // me.model.update({date: date, apptDur: me.model.calData.apptDur});
        me.scrollToTime('10:00', $(this));
      });
      // triggers Morning session click event when user access through keydown
      this.morning.keydown(function (e) {
        if (site.getKeycode(e) === 13) {
          $(this).trigger('click');
        }
      });
    }
    if (!!openStates.afternoon) {
      this.afternoon.css('cursor', 'pointer').click(function (e) {
        e.preventDefault();
        var date = new Date(me.firstDay.getTime());

        me.header.parent().attr('data-day-status', 'afternoon');
        // me.model.update({date: date, apptDur: me.model.calData.apptDur});
        me.scrollToTime('12:00', $(this));
      });
      // triggers afternoon session click event when user access through keydown
      this.afternoon.keydown(function (e) {
        if (site.getKeycode(e) === 13) {
          $(this).trigger('click');
        }
      });
    }
    if (!!openStates.evening) {
      this.evening.css('cursor', 'pointer').click(function (e) {
        e.preventDefault();
        var date = new Date(me.firstDay.getTime());

        me.header.parent().attr('data-day-status', 'evening');
        // me.model.update({date: date, apptDur: me.model.calData.apptDur});
        me.scrollToTime('17:00', $(this));
      });
      // triggers evening session click event when user access through keydown
      this.evening.keydown(function (e) {
        if (site.getKeycode(e) === 13) {
          $(this).trigger('click');
        }
      });
    }
    if (
      !findTimeSlotAvailableStatus.length &&
      slotCalendarView &&
      me.firstDay < now &&
      data.showNextWeek
    ) {
      nextCalendarDate.setDate(nextCalendarDate.getDate() + 7);
      me.model.isDateSelected = false;
      me.model.update({
        date: nextCalendarDate,
        apptDur: me.model.calData.apptDur
      });
    }
    if (!findTimeSlotAvailableStatus.length && slotCalendarView) {
      verifyNoSlotAvailable.removeClass('hidden');
    } else {
      verifyNoSlotAvailable.addClass('hidden');
    }
  };

  /**
   * CalendarTimeSlots is a class for concrete views of the CalendarModel.
   * It displays and manages the display logic for the Desktop Calendar Time Slot Selector.
   *
   *
   * @param thisDate Date required
   * @param openTimes Object required
   * @returns Object example: { morning: true, afternoon: false, evening: true }
   */
  apptBook.CalendarHeader.prototype.getStoreOpenStates = function (thisDate, openTimes) {
    var returnObj = {
      morning: false,
      afternoon: false,
      evening: false
    };
    var startMorningStr = '10:00';
    var endMorningStr = '11:45';
    var startAfternoonStr = '12:00';
    var endAfternoonStr = '16:45';
    var startEveningStr = '17:00';
    var endEveningStr = '22:00';
    var mergeDateTime = function (thisDate, timeStr) {
      var returnDate = new Date(thisDate);

      returnDate.setHours(timeStr.split(':')[0]);
      returnDate.setMinutes(timeStr.split(':')[1]);

      return returnDate;
    };
    var startMorningDate = mergeDateTime(thisDate, startMorningStr);
    var endMorningDate = mergeDateTime(thisDate, endMorningStr);
    var startAfternoonDate = mergeDateTime(thisDate, startAfternoonStr);
    var endAfternoonDate = mergeDateTime(thisDate, endAfternoonStr);
    var startEveningDate = mergeDateTime(thisDate, startEveningStr);
    var endEveningDate = mergeDateTime(thisDate, endEveningStr);
    var dayPartRanges = {
      morning: [startMorningDate, endMorningDate],
      afternoon: [startAfternoonDate, endAfternoonDate],
      evening: [startEveningDate, endEveningDate]
    };
    var openTimesDateKey = dateUtils.dateToString(thisDate, 'yyyy-mm-dd');

    if (!openTimes[openTimesDateKey]) {
      return returnObj;
    }
    // iterate over open sessions for that day
    for (var i = 0, len = openTimes[openTimesDateKey].length; i < len; i++) {
      // munge date strings to work with conversion method
      var startOpenStr =
        openTimesDateKey + ' ' + openTimes[openTimesDateKey][i]['start_time'] + ':00';
      var endOpenStr = openTimesDateKey + ' ' + openTimes[openTimesDateKey][i]['end_time'] + ':00';
      // get Date objects for the open & close times
      var startOpenDate = dateUtils.convertTimeString(startOpenStr);
      var endOpenDate = dateUtils.convertTimeString(endOpenStr);
      // create an array to represent this "open time" range
      var openRange = [startOpenDate, endOpenDate];

      // iterate over day parts
      for (var dayPart in dayPartRanges) {
        // if we've already found an open time for this day part, skip to next day part
        if (!!returnObj[dayPart]) {
          continue;
        }
        // if they overlap, set return value to true for this day part
        if (dateUtils.compareRanges(dayPartRanges[dayPart], openRange)) {
          returnObj[dayPart] = true;
          // skip to next day part
          continue;
        }
      } // end iterate over day parts
    } // end iterate over open sessions

    return returnObj;
  };

  /**
   * CalendarTimeSlots is a class for concrete views of the CalendarModel.
   * It displays and manages the display logic for the Desktop Calendar Time Slot Selector.
   *
   *
   * @param options Object required
   *
   *
   * @constructor
   */

  apptBook.CalendarTimeSlots = function (options) {
    apptBook.CalendarTimeSlots.superclass.constructor.call(this);
    this.initialized = false;
    this.container = options.container;
    this.colHeads = options.colHeads;
    this.timeSlotRow = options.timeSlotRow;
    this.timeSlotInterval = options.interval;
    this.timeContainer = options.timeContainer;
    this.timeSlotsContainer = options.timeSlotsContainer;
    this.slotLabels = options.slotLabels;
    this.closedCopy = options.closedCopy;
    this.calDayOfWeekFormat = options.calDayOfWeekFormat;

    this.slots = [
      { hour: '7:00' },
      { hour: '7:15' },
      { hour: '7:30' },
      { hour: '7:45' },
      { hour: '8:00' },
      { hour: '8:15' },
      { hour: '8:30' },
      { hour: '8:45' },
      { hour: '9:00' },
      { hour: '9:15' },
      { hour: '9:30' },
      { hour: '9:45' },
      { hour: '10:00' },
      { hour: '10:15' },
      { hour: '10:30' },
      { hour: '10:45' },
      { hour: '11:00' },
      { hour: '11:15' },
      { hour: '11:30' },
      { hour: '11:45' },
      { hour: '12:00' },
      { hour: '12:15' },
      { hour: '12:30' },
      { hour: '12:45' },
      { hour: '13:00' },
      { hour: '13:15' },
      { hour: '13:30' },
      { hour: '13:45' },
      { hour: '14:00' },
      { hour: '14:15' },
      { hour: '14:30' },
      { hour: '14:45' },
      { hour: '15:00' },
      { hour: '15:15' },
      { hour: '15:30' },
      { hour: '15:45' },
      { hour: '16:00' },
      { hour: '16:15' },
      { hour: '16:30' },
      { hour: '16:45' },
      { hour: '17:00' },
      { hour: '17:15' },
      { hour: '17:30' },
      { hour: '17:45' },
      { hour: '18:00' },
      { hour: '18:15' },
      { hour: '18:30' },
      { hour: '18:45' },
      { hour: '19:00' },
      { hour: '19:15' },
      { hour: '19:30' },
      { hour: '19:45' },
      { hour: '20:00' },
      { hour: '20:15' },
      { hour: '20:30' },
      { hour: '20:45' },
      { hour: '21:00' },
      { hour: '21:15' },
      { hour: '21:30' },
      { hour: '21:45' }
    ];

    for (var i = 0, len = this.slots.length; i < len; i += 1) {
      if (this.slotLabels && this.slotLabels[i]) {
        this.slots[i].label = this.slotLabels[i];
      } else {
        this.slots[i].label = ' ';
      }
    }
  };

  ctrlopt.extend(apptBook.CalendarTimeSlots, ctrlopt.mvc.AbstractView);

  apptBook.CalendarTimeSlots.prototype.defaultController = function (data) {
    return null;
  };

  apptBook.CalendarTimeSlots.prototype.onUpdate = function (data) {
    this.calData = data;
    this.buildWeekView();
  };

  apptBook.CalendarTimeSlots.prototype.buildWeekView = function () {
    var hText,
      sText,
      hour,
      row,
      len = 7,
      endViMorning = '11:45',
      startViAfternoon = '12:00',
      endViAfternoon = '17:45',
      startViEvening = '18:00',
      startvi = 0,
      startviH = 0,
      startviM = 0,
      endVi = 0,
      endViH = 0,
      endViM = 0,
      t1,
      t2,
      ti,
      parts,
      stateofDay = this.container.attr('data-day-status'),
      myDate = this.calData.myDate,
      dayOfWeek = startDayShift(myDate.getDay());
    var me = this;

    this.firstDay = new Date(myDate.getTime());
    this.firstDay.setDate(this.firstDay.getDate() - dayOfWeek);
    this.firstDay.setHours(0, 0, 0, 0);
    this.lastDay = new Date(this.firstDay.getTime());
    this.lastDay.setDate(this.lastDay.getDate() + 6);
    this.lastDay.setHours(23, 59, 59, 999);
    this.openTimes = this.calData.openTimes;
    if (typeof this.calData.timeSlotInterval != 'undefined') {
      this.timeSlotInterval = this.calData.timeSlotInterval;
    }

    t1 = new Date(); // Start Time Slot
    t2 = new Date(); // End Time Slot
    ti = new Date(); // Current Time Slot

    if (this.calData.apptTime) {
      var apptTime = dateUtils.convertTimeString(this.calData.apptTime),
        apptHour = apptTime.getHours();

      if (apptHour >= startViAfternoon.split(':')[0]) {
        stateofDay = 'afternoon';
      } else if (apptHour >= startViEvening.split(':')[0]) {
        stateofDay = 'evening';
      } else {
        stateofDay = 'morning';
      }
      this.container.attr('data-day-status', stateofDay);
    }

    if (stateofDay == 'morning') {
      startVi = this.firstDay.getHours() + ':' + this.firstDay.getMinutes();
      startViH = this.firstDay.getHours();
      startViM = this.firstDay.getMinutes();
      endVi = endViMorning;
      endViH = endVi.split(':')[0];
      endViM = ('0' + endVi.split(':')[1]).slice(-2);
    } else if (stateofDay == 'afternoon') {
      startVi = startViAfternoon;
      startViH = startVi.split(':')[0];
      startViM = ('0' + startVi.split(':')[1]).slice(-2);
      endVi = endViAfternoon;
      endViH = endVi.split(':')[0];
      endViM = ('0' + endVi.split(':')[1]).slice(-2);
    } else if (stateofDay == 'evening') {
      startViH = startViEvening.split(':')[0];
      startViM = ('0' + startViEvening.split(':')[1]).slice(-2);
      endVi = this.lastDay.getHours() + ':' + this.lastDay.getMinutes();
      endViH = this.lastDay.getHours();
      endViM = this.lastDay.getMinutes();
    } else {
      startViH = this.firstDay.getHours();
      startViM = ('0' + this.firstDay.getMinutes()).slice(-2);
      endViH = this.lastDay.getHours();
      endViM = this.lastDay.getMinutes();
    }

    t1.setHours(startViH, startViM, 0, 0);
    t2.setHours(endViH, endViM, 0, 0);

    for (var i = 0; i < len; i += 1) {
      var myDayDate = new Date(this.firstDay.getTime());

      myDayDate.setDate(myDayDate.getDate() + i);
      hText = moment(myDayDate).format(this.calDayOfWeekFormat).replace('.', '');
      this.colHeads.eq(i).removeClass('hilite').text(hText);
    }

    if (this.calData.hilite) {
      this.colHeads.eq(dayOfWeek).addClass('hilite');
    }

    var intervalFactor = this.timeSlotInterval / 15;

    if (intervalFactor == 0) {
      intervalFactor = 4;
    }

    this.timeSlotsContainer.empty();
    len = this.slots.length;

    // build an array of each day displayed on the calendar
    this.calendarDays = [this.firstDay];
    var oneDay = 24 * 60 * 60 * 1000;
    if (locale === 'he_IL' || locale === 'en_IL') {
      for (var i = 0; i < 6; i++) {
        var prevDay = this.calendarDays[i];
        var nextDay = new Date(prevDay.getTime() + oneDay);

        this.calendarDays.push(nextDay);
      }
    } else {
      for (var i = 0; i < 7; i++) {
        var prevDay = this.calendarDays[i];
        var nextDay = new Date(prevDay.getTime() + oneDay);

        this.calendarDays.push(nextDay);
      }
    }
    // reverse the Calendar days if direction is rtl
    if (document.documentElement.dir === 'rtl') {
      me.calendarDays.reverse();
    }

    for (var i = 0; i < len; i += intervalFactor) {
      sText = this.slots[i].label;
      hour = this.slots[i].hour;
      parts = hour.split(':');
      ti.setHours(parts[0], parts[1], 0, 0);
      row = this.timeSlotRow.clone();
      if (locale === 'he_IL' || locale === 'en_IL') {
        row = $(row).reverseChildren();
      }
      var thisDay = new Date(this.calendarDays[i]);
      row
        .find('td')

        .attr('data-hour', hour)
        .text(sText)
        .css('display', 'table-cell')
        .each(function (idx) {
          var myDateTime = me.calendarDays[idx];

          myDateTime.setHours(parts[0], parts[1], 0, 0);

          var to = new Date(myDateTime.getTime()); // Open Store Time Slot
          var tc = new Date(myDateTime.getTime()); // Close Store Time Slot
          var openTimesDateKey = dateUtils.dateToString(myDateTime, 'yyyy-mm-dd');

          if (
            typeof me.openTimes[openTimesDateKey] !== 'undefined' &&
            me.openTimes[openTimesDateKey].length
          ) {
            // get HH:mm:ss string for the open & close times
            var openStoreHourStr = me.openTimes[openTimesDateKey][0]['start_time'].split(':');
            var closeStoreHourStr = me.openTimes[openTimesDateKey][0]['end_time'].split(':');

            // get Date objects for the open & close times
            to.setHours(openStoreHourStr[0], openStoreHourStr[1], 0, 0);
            tc.setHours(closeStoreHourStr[0], closeStoreHourStr[1], 0, 0);
            if (myDateTime.getTime() < to.getTime() || myDateTime.getTime() >= tc.getTime()) {
              $(this).text(me.closedCopy); // Set this time slot as Closed.
            }
          }

          $(this).attr('data-date-time', myDateTime);
          $(this).attr('aria-label', myDateTime);
        });
      if (locale === 'he_IL' || locale === 'en_IL') {
        this.timeSlotsContainer.append($(row).reverseChildren());
      } else {
        this.timeSlotsContainer.append(row);
      }
    }
    this.timeSlotsElems = this.timeSlotsContainer.find('td');
    this.setSlots();
    if (this.calData.apptTime) {
      this.setApptTime();
    }
    if (this.calData.openTimes) {
      this.handleStoreOpenTimes();
    }
  };

  //
  // This function compares the dates on the calendar to the times that the store is open
  // and sets class names on the time slots accordingly
  apptBook.CalendarTimeSlots.prototype.handleStoreOpenTimes = function () {
    var me = this;

    this.timeSlotsElems.each(function (idx, ele) {
      $td = $(this);
      var slotDateTimeStr = $td.attr('data-date-time');

      slotDateTime = new Date(slotDateTimeStr);
      // build key from date values
      var openTimesDateKey = dateUtils.dateToString(slotDateTime, 'yyyy-mm-dd');
      // use that key to look up store-open times for that day
      var openTimes = me.calData.openTimes;

      if (openTimes[openTimesDateKey]) {
        // iterate over open sessions for that day
        for (var j = 0, jlen = openTimes[openTimesDateKey].length; j < jlen; j++) {
          var storeIsOpen = false;
          // munge date strings to work with conversion method
          var startOpenStr =
            openTimesDateKey + ' ' + openTimes[openTimesDateKey][j]['start_time'] + ':00';
          var endOpenStr =
            openTimesDateKey + ' ' + openTimes[openTimesDateKey][j]['end_time'] + ':00';
          // get Date objects for the open & close times
          var startOpenDate = dateUtils.convertTimeString(startOpenStr);
          var endOpenDate = dateUtils.convertTimeString(endOpenStr);

          // add class name if this slot's time is within an open time range
          if (dateUtils.inRange(slotDateTime, startOpenDate, endOpenDate)) {
            $td.addClass('store_open');
          }
        }
      }
    }); // end this.timeSlotsElems.each
  };

  apptBook.CalendarTimeSlots.prototype.processSlot = function (start, end, interval) {
    var startIndex = 0,
      myDay = new Date(start.getTime()),
      myDayOfWeek = startDayShift(myDay.getDay()),
      stateofDay = this.container.attr('data-day-status'),
      col = this.timeSlotsContainer.find('.day-' + myDayOfWeek),
      interval = interval ? interval : 60,
      dMinute = Math.ceil(start.getMinutes() / interval),
      startHour = dMinute * interval === 60 ? start.getHours() + 1 : start.getHours(),
      startMin = dMinute * interval === 0 || dMinute * interval === 60 ? '00' : dMinute * interval,
      startTime = startHour + ':' + startMin,
      sHrDate = new Date(start.getTime()),
      len = this.slots.length,
      me = this;
    var intervalFactor = this.timeSlotInterval / 15;

    if (intervalFactor == 0) {
      intervalFactor = 4;
    }

    for (var i = 0; i < len; i += intervalFactor) {
      if (this.slots[i].hour === startTime) {
        startIndex = i;
        break;
      }
    }

    var secondSlots = this.calData.secondTimeSlots;
    var firstApptDuration = this.calData.myNonSubsequentDurationWithPadding
      ? this.calData.myNonSubsequentDurationWithPadding
      : this.calData.mySubsequentDurationWithPadding;

    // If we are /editing/ an existing appointment then this will not be populated and we need to grab the appointment duration from here
    if (!firstApptDuration) {
      firstApptDuration = this.calData.apptDur;
    }

    for (var i = startIndex; i < len; i += intervalFactor) {
      var timeLeft,
        minLeft,
        sT = this.slots[i].hour.split(':');

      sHrDate.setHours(sT[0], sT[1], 0, 0);
      timeLeft = end.getTime() - sHrDate.getTime();
      minLeft = Math.floor(timeLeft / 60000);

      if (minLeft < firstApptDuration) {
        break;
      } else {
        // So we are about to mark this (micro)slot as available.... But it is only available IF this time is also available
        // on some slot in secondSlots at the subsequent offet from this time.
        if (secondSlots) {
          var invalidDueToSubsequentSelf = this.calData.mySubsequentDuration > 0 ? 1 : 0;
          var subSelfStart = sHrDate.getTime() + this.calData.myNonSubsequentDuration * 60 * 1000;
          var subSelfEnd = subSelfStart + this.calData.mySubsequentDuration * 60 * 1000;

          // If we can find a large timeslot in secondSlots that can accomodate our subsequent appointment(s)
          // Then we can use this.
          for (var j = 0; j < secondSlots.length; j++) {
            var slotStart = Drupal.appointmentBooking.dateUtils
              .convertTimeString(secondSlots[j].start_date)
              .getTime();
            var slotEnd = Drupal.appointmentBooking.dateUtils
              .convertTimeString(secondSlots[j].end_date)
              .getTime();

            if (subSelfStart >= slotStart && subSelfEnd <= slotEnd) {
              invalidDueToSubsequentSelf = 0;
            }
            if (invalidDueToSubsequentSelf == 0) {
              break;
            }
          }
        }
        if (!invalidDueToSubsequentSelf) {
          // Need merge conflict here
          col
            .eq(parseInt(i / intervalFactor))
            .attr('tabindex', '0')
            .addClass('enabled')
            .click(function (e) {
              var slotDate = new Date(start.getTime()),
                hour,
                min,
                $this = $(this);

              me.timeSlotsElems.removeClass('selected');
              $this.addClass('selected');
              hour = $this.attr('data-hour').split(':')[0];
              min = $this.attr('data-hour').split(':')[1];
              slotDate.setHours(parseInt(hour, 10));
              slotDate.setMinutes(parseInt(min));
              me.model.setSelection(slotDate, me);
            });
          // Timeslot selection arrow key navigation
          col
            .eq(parseInt(i / intervalFactor))
            .attr({
              tabindex: '0',
              role: 'radio'
            })
            .addClass('enabled')
            .keyup(function (e) {
              var bookBtn = $('.book-now-bar').find('#appt-book-book-submit');
              var $this = $(this);

              switch (site.getKeycode(e)) {
                case 39: // right arrow
                  $this.closest('td').next().focus();
                  break;
                case 37: // left arrow
                  $this.closest('td').prev().focus();
                  break;
                case 40: // down arrow
                  $this
                    .closest('tr')
                    .next()
                    .find('td:eq(' + $(this).closest('td').index() + ')')
                    .focus();
                  break;
                case 38: // up arrow
                  $this
                    .closest('tr')
                    .prev()
                    .find('td:eq(' + $(this).closest('td').index() + ')')
                    .focus();
                  break;
                case 13:
                  $this.trigger('click');
                  bookBtn.focus();
                  break;
              }
            });
        }
      }
    }
  };

  apptBook.CalendarTimeSlots.prototype.setSlots = function () {
    var slotLength;
    var slotTiming;
    var columnLength;
    var slotsColumn;
    var slotsCount;
    var setTop = 0;
    var setLeft = 0;
    var rowCount = 0;
    var columnCount = 0;
    var timeslotsRow = this.timeSlotsContainer.find('tr');
    var timeslotsRowValue = timeslotsRow.eq(rowCount).find('td').eq(columnCount);
    var timeslotsRowWidth = timeslotsRowValue.outerWidth(true);
    var timeslotsRowHeight = timeslotsRowValue.outerHeight(true);
    var slotRowLength = timeslotsRow.length;
    var timeslots = this.calData.timeslots;
    var timeslotsCalendar = this.container.find('.weekdays').hasClass('calendar-view');

    if (!timeslots) {
      return;
    }
    this.firstDay.setHours(0, 0, 0, 0);
    // iterate over all artist-open date/times received in API response
    for (var i = 0, len = timeslots.length; i < len; i += 1) {
      var start = dateUtils.convertTimeString(timeslots[i].start_date),
        end = dateUtils.convertTimeString(timeslots[i].end_date),
        startTime = start.getTime();

      // if a date falls between start & end date of calendar, pass it to display logic
      if (startTime >= this.firstDay.getTime() && startTime <= this.lastDay.getTime()) {
        this.processSlot(start, end, this.timeSlotInterval);
      }
    }
    if (!site.client.isMobile && timeslotsCalendar) {
      this.timeSlotsContainer.find('td').hide();
      for (slotTiming = 0; slotTiming < slotRowLength; slotTiming += 1) {
        slotsColumn = timeslotsRow.eq(rowCount).find('td');
        slotsCount = slotsColumn.eq(columnCount);
        columnLength = slotsColumn.length;
        slotLength = slotRowLength - 1;
        if (slotsCount.hasClass('enabled')) {
          slotsCount
            .offset({
              top: setTop,
              left: setLeft
            })
            .show();
          setTop += timeslotsRowHeight;
        }
        rowCount++;
        if (slotTiming === slotLength && columnCount < columnLength) {
          slotTiming = 0;
          rowCount = 0;
          setTop = 0;
          setLeft += timeslotsRowWidth;
          columnCount++;
        }
      }
    }
  };

  apptBook.CalendarTimeSlots.prototype.setApptTime = function () {
    var me = this,
      apptDate = dateUtils.convertTimeString(this.calData.apptTime),
      apptTime = apptDate.getTime(),
      apptHour = apptDate.getHours().toString(),
      apptMinutes = ('0' + apptDate.getMinutes()).slice(-2),
      apptTimeDate = apptHour + ':' + apptMinutes;

    if (apptTime >= this.firstDay.getTime() && apptTime <= this.lastDay.getTime()) {
      this.timeSlotsContainer.find('.day-' + startDayShift(apptDate.getDay())).each(function () {
        var $this = $(this);
        var $hour = $(this).attr('data-hour');

        if ($this.attr('data-hour') === apptTimeDate) {
          $this.addClass('selected').addClass('enabled');
          me.model.setSelection(apptDate, me);
        }
      });
    }
  };

  apptBook.CalendarTimeSlots.prototype.convertDateString = function (tString) {
    if (typeof tString != 'string' || tString.match(/^\d\d\d\d-\d\d-\d\d$/) === null) {
      return null;
    }
    var dateArray, y, m, d;

    dateArray = tString.split('-');

    y = parseInt(dateArray[0], 10);
    m = parseInt(dateArray[1], 10) - 1;
    d = parseInt(dateArray[2], 10);

    return new Date(y, m, d);
  };

  /**
   * CalDatePicker is a class faor a concrete controller of the CalendarModel.
   * It manages the pickaday date picker and uses its input to update the Calendar Model
   *
   *
   * @param options Object required
   *
   *
   * @constructor
   */

  apptBook.CalDatePicker = function (options) {
    apptBook.CalDatePicker.superclass.constructor.call(this);
    var offSet,
      me = this,
      $bod = options.jqBod,
      overlay = options.overlay,
      closeBtn = options.closeBtn,
      calContainer = options.calContainer,
      weekContainer = options.weekContainer,
      dpField = options.datepickerField,
      dpTrigger = options.datepickerTrigger,
      OAB_start_from_monday = Drupal.settings.globals_variables.OAB_start_from_monday ? 1 : 0,
      pikaday = new Pikaday({
        field: dpField[0],
        firstDay: OAB_start_from_monday,
        minDate: new Date(),
        maxDate: new Date(2020, 12, 31),
        yearRange: [2000, 2020],
        showMonthAfterYear: oab_show_month_after_year ? true : false,
        yearSuffix: oab_year_suffix,
        bound: false,
        container: calContainer[0],
        numberOfMonths: 1,
        onSelect: onDateSelect,
        disableDayFn: disableDate,
        i18n: {
          months: moment.months(),
          weekdays: moment.localeData()._weekdays,
          // Moment adds periods to the ends of short day names, we don't want those...
          weekdaysShort: moment.localeData()._weekdaysShort.map(function (shortDay) {
            return shortDay.replace('.', '');
          })
        }
      });

    $bod.prepend(overlay);

    function openOverlay() {
      overlay.css('display', 'block');
      if (!me.model.isDateSelected) {
        month = me.model.calData.myDate.getMonth();
        currentMonth = me.model.calData.currentDate.getMonth();
        pikaday.gotoMonth(month);
        if (month != currentMonth) {
          me.model.datepickerContainer.find('.is-selected').removeClass('is-selected');
        }
      } else {
        pikaday.gotoDate(me.model.calData.myDate);
      }
    }

    function closeOverlay() {
      overlay.css('display', 'none');
    }

    function onDateSelect(e) {
      var d = pikaday.getDate();

      if (me.model) {
        me.model.calData.currentDate = d;
        me.model.isDateSelected = true;
        me.model.update({
          date: d,
          hilite: true,
          apptDur: me.model.calData.apptDur
        });
      }
      closeOverlay();
      me.model.calData.showNextWeek = false;
    }

    function disableDate(date) {
      if (!me.model) {
        return;
      }
      // build key from date values
      var dateKey = dateUtils.dateToString(date, 'yyyy-mm-dd');
      // use that key to look up store-open times for that day
      var openTimes = me.model.calData.openTimes;
      var datesInvalid = me.model.calData.datesInvalid;

      if (typeof openTimes[dateKey] === 'undefined' || !openTimes[dateKey].length) {
        return date;
      }
      if ($.inArray(dateKey, datesInvalid) > 0) {
        return date;
      }
    }

    dpTrigger.click(openOverlay);
    closeBtn.click(closeOverlay);
    dpTrigger.keydown(function (e) {
      $target = $(this);
      var dpCalCont = $('.pika-table').find('td button.pika-button.pika-day:eq(0)').focus();
      var calenderContainer = $('.js-datepicker-container');

      if (site.getKeycode(e) === 13) {
        var expanded = $(this).attr('aria-expanded');

        expanded == 'true'
          ? (function () {
              $target.attr('aria-expanded', 'false'), closeOverlay(), $target.focus();
            })()
          : (function () {
              $target.attr('aria-expanded', 'true'),
                openOverlay(),
                dpCalCont,
                site.restrict_navigation(calenderContainer),
                $('td.is-disabled button.pika-button.pika-day').attr('tabindex', '-1');
            })();
        $(this).attr('aria-expanded') === 'true'
          ? closeCalenderOverlay($(this))
          : openCalenderOverlay($(this));
      }
    });
  };
  ctrlopt.extend(apptBook.CalDatePicker, ctrlopt.mvc.AbstractController);

  /* Mobile Appointment Select */

  /* Mobile Date Picker - Date Picker */

  /**
   * CalDatePickerMobile is a sub-class of CalDatePicker. It is a concrete controller of the CalendarModel.
   * It manages the pickaday date picker and uses its input to update the Calendar Model
   *
   *
   * @param options Object required
   *
   *
   * @constructor
   */

  apptBook.CalDatePickerMobile = function (options) {
    apptBook.CalDatePickerMobile.superclass.constructor.call(this);
    var me = this,
      foregroundNode,
      backgroundNode,
      overlay = options.overlay,
      $bod = options.jqBod,
      container = options.container,
      closeBtn = options.closeBtn,
      calContainer = options.calContainer,
      dpField = options.datepickerField,
      dpTrigger = options.datepickerTrigger,
      dpControls = options.dpControls,
      OAB_start_from_monday = Drupal.settings.globals_variables.OAB_start_from_monday ? 1 : 0;

    $bod.prepend(overlay);

    pikaday = new Pikaday({
      field: dpField[0],
      firstDay: OAB_start_from_monday,
      minDate: new Date(),
      maxDate: new Date(2020, 12, 31),
      yearRange: [2000, 2020],
      showMonthAfterYear: oab_show_month_after_year ? true : false,
      yearSuffix: oab_year_suffix,
      bound: false,
      container: calContainer[0],
      onSelect: onDateSelect,
      disableDayFn: disableDate,
      i18n: {
        months: moment.months(),
        weekdays: moment.localeData()._weekdays,
        // Moment adds periods to the ends of short day names, we don't want those...
        weekdaysShort: moment.localeData()._weekdaysShort.map(function (shortDay) {
          return shortDay.replace('.', '');
        })
      }
    });

    function disableDate(date) {
      if (!me.model) {
        return;
      }
      // build key from date values
      var dateKey = dateUtils.dateToString(date, 'yyyy-mm-dd');
      // use that key to look up store-open times for that day
      var openTimes = me.model.calData.openTimes;
      var datesInvalid = me.model.calData.datesInvalid;

      if (typeof openTimes[dateKey] === 'undefined' || !openTimes[dateKey].length) {
        return date;
      }
      if ($.inArray(dateKey, datesInvalid) > 0) {
        return date;
      }
    }

    function openOverlay() {
      me.model.winPos = $(window).scrollTop();
      me.model.headContent = $(this).find('.cal-copy');
      me.model.hDefContent = $(this).find('.default-cal-copy');
      $(window).scroll(0);
      container.scrollTop(0);
      h = $(window).height() - 10;
      var timeSlotData = me.model.calData.timeslots;
      var currentAvailableDateSlot;
      var activeTimeSlot;
      var selectedDate;

      overlay.addClass('overlay-container').css('display', 'block');
      pikaday.gotoDate(new Date());
      if (timeSlotData.length) {
        currentAvailableDateSlot = timeSlotData[0].start_date;
        activeTimeSlot = currentAvailableDateSlot.split(/[- :]/);
        selectedDate = currentAvailableDateSlot.replace(/-/g, '/');
        overlay.find('.js-date-picker-no-slot').addClass('hidden');
        overlay.find('td').removeClass('is-selected');
        overlay.find('td[data-day=' + Number(activeTimeSlot[2]) + ']').addClass('is-selected');
        me.model.update({
          date: new Date(selectedDate),
          apptDur: me.model.calData.apptDur
        });
      }
    }

    function closeOverlay() {
      overlay.css('display', 'none');
      $(window).scrollTop(me.model.winPos);
    }

    function onDateSelect(e) {
      var d = pikaday.getDate();

      me.model.isDateSelected = true;
      if (me.model) {
        me.model.update({
          date: d,
          hilite: true,
          apptDur: me.model.calData.apptDur
        });
      }
    }

    dpTrigger.click(openOverlay);
    closeBtn.click(closeOverlay);
  };

  ctrlopt.extend(apptBook.CalDatePickerMobile, ctrlopt.mvc.AbstractController);

  /* End Mobile Date Picker */

  /* Mobile Calendar Header */

  /**
   * CalendarHeaderMobile is a sub-class of CalendarHeader. It is a concrete view of the CalendarModel.
   * It displays and manages the display logic for the Desktop Time Slot Calendar Header.
   *
   *
   * @param header JQuery required    a jquery object that contains a DOM element that represents the root element of the
   *                                  header.
   *
   *
   * @constructor
   */

  apptBook.CalendarHeaderMobile = function (header) {
    apptBook.CalendarHeaderMobile.superclass.constructor.call(this);
    this.initialized = false;
    this.header = header;
    this.hDefContent = this.header.find('.default-cal-copy');
    this.headContent = this.header.find('.cal-copy');
    this.calHeaderMobileDateFormat = this.header.attr('data-cal-header-mobile-date-format');
    this.headCopy = this.headContent.html();
  };

  ctrlopt.extend(apptBook.CalendarHeaderMobile, ctrlopt.mvc.AbstractView);

  apptBook.CalendarHeaderMobile.prototype.onUpdate = function (data) {
    this.calData = data;
    var OAB_show_AM_PM =
      Drupal.settings.globals_variables.OAB_show_AM_PM !== 'undefined'
        ? Drupal.settings.globals_variables.OAB_show_AM_PM
        : 0;
    var headOut,
      firstDay,
      lastDay,
      me = this,
      myDate = this.calData.myDate,
      dayOfWeek = startDayShift(myDate.getDay()),
      myDateEnd = new Date(myDate.getTime());

    myDateEnd.setTime(myDateEnd.getTime() + me.model.calData.apptDur * 60000);

    firstDay = new Date(myDate.getTime());
    firstDay.setDate(firstDay.getDate() - dayOfWeek);
    firstDay.setHours(0, 0, 0, 0);

    lastDay = new Date(firstDay.getTime());
    lastDay.setDate(lastDay.getDate() + 6);
    lastDay.setHours(23, 59, 59, 999);

    if (this.calHeaderMobileDateFormat) {
      // Moving forward the date format will come from CMS
      headOut = moment(myDate).format(this.calHeaderMobileDateFormat);
    } else {
      // Legacy support date formatting
      if (OAB_show_AM_PM) {
        // Like 'OCTOBRE 7, 2019 11:34 AM'
        headOut = moment(myDate).format('MMMM D, YYYY h:mmA').toUpperCase();
      } else {
        // Like 'OCTOBRE 7, 2019 14:34'
        headOut = moment(myDate).format('MMMM D, YYYY H:mm').toUpperCase();
      }
    }

    this.headContent.html(headOut);

    if (!this.model.dateSet) {
      me.hDefContent.removeClass('hidden');
      me.headContent.addClass('hidden');
    } else {
      me.hDefContent.addClass('hidden');
      me.headContent.removeClass('hidden');
    }
  };

  /* End Mobile Calendar Header */

  /* Mobile Time Slot Select */

  /**
   * CalendarTimeSlotsMobile is a sub-class of CalendarTimeSlots. It is a concrete view of the CalendarModel.
   * It displays and manages the display logic for the Mobile Time Slot Selector.
   *
   *
   * @param options Object required
   *
   *
   * @constructor
   */

  apptBook.CalendarTimeSlotsMobile = function (options) {
    apptBook.CalendarTimeSlotsMobile.superclass.constructor.call(this, options);
  };

  ctrlopt.extend(apptBook.CalendarTimeSlotsMobile, apptBook.CalendarTimeSlots);

  apptBook.CalendarTimeSlotsMobile.prototype.onUpdate = function (data) {
    this.calData = data;
    if (!this.initialized) {
      this.buildWeekView();
      // this.timeContainer.hide();
      this.initialized = true;
    } else {
      // this.timeContainer.show();
      this.timeSlotsElems.removeClass('selected');
      this.buildWeekView();
    }
  };

  apptBook.CalendarTimeSlotsMobile.prototype.setCellDateTimes = function () {
    var $tds = this.timeSlotsElems;
    var myDateTime = new Date(this.calData.myDate);

    $tds.each(function (idx) {
      var $td = $(this);
      var parts = $td.data('hour').split(':');

      myDateTime.setHours(parts[0], parts[1], 0, 0);
      $td.attr('data-date-time', myDateTime);
    });
  };

  apptBook.CalendarTimeSlotsMobile.prototype.scrollToOpenTime = function () {
    var $tds = this.timeSlotsElems;
    // switched from .store_open to .enabled - forward the user to the first available timeslot
    var $firstOpen = $tds.filter('.enabled').first();
    var winTop = $(window).scrollTop();
    var parent = this.model.datepickerContainer.parents('.date-picker-container');

    if ($firstOpen.length) {
      parent.animate({ scrollTop: parent.scrollTop() + $firstOpen.offset().top - winTop }, 1000);
    }
  };

  apptBook.CalendarTimeSlotsMobile.prototype.buildWeekView = function () {
    var hour, sText, row, rowCount, rows, rowIdx, tds, tdPerRow, tdElem, mod, cur, td;
    var myDate = this.calData.myDate;

    if (!this.initialized) {
      this.tds = this.timeSlotRow.find('td').remove();
      this.tdPerRow = this.tds.length;
    }
    tdElem = this.tds.first();
    rowCount = Math.ceil(this.slots.length / this.tdPerRow);

    if (this.initialized) {
      this.timeSlotsContainer.empty();
    }
    for (var i = 0; i < rowCount; i += 1) {
      row = this.timeSlotRow.clone();
      this.timeSlotsContainer.append(row);
    }

    rows = this.timeSlotsContainer.find('tr');
    i = 0;
    rowIdx = 0;
    openTimes = this.calData.openTimes;

    if (typeof this.calData.timeSlotInterval != 'undefined') {
      this.timeSlotInterval = this.calData.timeSlotInterval;
    }

    var intervalFactor = this.timeSlotInterval / 15;

    // value of 0 should be treated as 60
    if (intervalFactor == 0) {
      intervalFactor = 4;
    }

    for (var len = this.slots.length; i < len; i += intervalFactor) {
      sText = this.slots[i].label;
      hour = this.slots[i].hour;

      td = tdElem.clone();

      var myDateTime = myDate ? new Date(myDate.getTime()) : new Date();

      myDateTime.setHours(hour.split(':')[0], hour.split(':')[1], 0, 0);

      var to = new Date(myDateTime.getTime()); // Open Store Time Slot
      var tc = new Date(myDateTime.getTime()); // Close Store Time Slot
      var openTimesDateKey = dateUtils.dateToString(myDateTime, 'yyyy-mm-dd');

      if (
        typeof openTimes[openTimesDateKey] !== 'undefined' &&
        openTimes[openTimesDateKey].length
      ) {
        // get HH:mm:ss string for the open & close times
        var openStoreHourStr = openTimes[openTimesDateKey][0]['start_time'].split(':');
        var closeStoreHourStr = openTimes[openTimesDateKey][0]['end_time'].split(':');

        // get Date objects for the open & close times
        to.setHours(openStoreHourStr[0], openStoreHourStr[1], 0, 0);
        tc.setHours(closeStoreHourStr[0], closeStoreHourStr[1], 0, 0);
        if (myDateTime.getTime() < to.getTime() || myDateTime.getTime() >= tc.getTime()) {
          td.text(this.closedCopy); // Set this time slot as Closed.
          td.addClass('store_closed');
        } else {
          td.text(sText);
        }
      } else {
        td.text(sText);
      }
      td.attr('data-hour', hour);

      rows.eq(rowIdx).append(td);

      cur = i + 1;
      mod = cur % this.tdPerRow;

      if (mod === 0) {
        rowIdx += 1;
      }
    }
    this.timeSlotsElems = this.timeSlotsContainer.find('td');
    this.setCellDateTimes();
    this.setSlots();
    if (this.calData.apptTime) {
      this.setApptTime();
    }
    if (this.calData.openTimes) {
      this.handleStoreOpenTimes();
    }
    this.scrollToOpenTime();
  };

  apptBook.CalendarTimeSlotsMobile.prototype.processSlot = function (start, end, interval) {
    var startIndex = 0,
      myDay = new Date(start.getTime()),
      myDayOfWeek = startDayShift(myDay.getDay()),
      // startDay = myDay.setHours(0,0,0,0),
      stateofDay = this.container.attr('data-day-status'),
      col = this.timeSlotsContainer.find('.day-' + myDayOfWeek),
      interval = interval ? interval : 60,
      dMinute = Math.ceil(start.getMinutes() / interval),
      startHour = dMinute * interval === 60 ? start.getHours() + 1 : start.getHours(),
      startMin = dMinute * interval === 0 || dMinute * interval === 60 ? '00' : dMinute * interval,
      startTime = startHour + ':' + startMin,
      sHrDate = new Date(start.getTime()),
      len = this.slots.length,
      me = this;
    var intervalFactor = this.timeSlotInterval / 15;

    if (intervalFactor == 0) {
      intervalFactor = 4;
    }

    for (var i = 0; i < len; i += intervalFactor) {
      if (this.slots[i].hour === startTime) {
        startIndex = i;
        break;
      }
    }

    var secondSlots = this.calData.secondTimeSlots;
    var firstApptDuration = this.calData.myNonSubsequentDurationWithPadding
      ? this.calData.myNonSubsequentDurationWithPadding
      : this.calData.mySubsequentDurationWithPadding;

    for (i = startIndex; i < len; i += intervalFactor) {
      var timeLeft,
        minLeft,
        sT = this.slots[i].hour.split(':');

      sHrDate.setHours(sT[0], sT[1], 0, 0);
      timeLeft = end.getTime() - sHrDate.getTime();
      minLeft = Math.floor(timeLeft / 60000);

      if (minLeft < firstApptDuration) {
        break;
      } else {
        // So we are about to mark this (micro)slot as available.... But it is only available IF this time is also available
        // on some slot in secondSlots at the subsequent offet from this time.
        if (secondSlots) {
          var invalidDueToSubsequentSelf = this.calData.mySubsequentDuration > 0 ? 1 : 0;
          var subSelfStart = sHrDate.getTime() + this.calData.myNonSubsequentDuration * 60 * 1000;
          var subSelfEnd = subSelfStart + this.calData.mySubsequentDuration * 60 * 1000;

          // If we can find a large timeslot in secondSlots that can accomodate our subsequent appointment(s)
          // Then we can use this.
          for (var j = 0; j < secondSlots.length; j++) {
            var slotStart = Drupal.appointmentBooking.dateUtils
              .convertTimeString(secondSlots[j].start_date)
              .getTime();
            var slotEnd = Drupal.appointmentBooking.dateUtils
              .convertTimeString(secondSlots[j].end_date)
              .getTime();

            if (subSelfStart >= slotStart && subSelfEnd <= slotEnd) {
              invalidDueToSubsequentSelf = 0;
            }
            if (invalidDueToSubsequentSelf == 0) {
              break;
            }
          }
        }
        if (!invalidDueToSubsequentSelf) {
          // Need merge conflict here
          this.timeSlotsElems
            .eq(parseInt(i / intervalFactor))
            .addClass('enabled')
            .click(function (e) {
              var slotDate = new Date(start.getTime()),
                hour,
                min,
                $this = $(this);

              me.timeSlotsElems.removeClass('selected');
              $this.addClass('selected');
              hour = $this.attr('data-hour').split(':')[0];
              min = $this.attr('data-hour').split(':')[1];
              slotDate.setHours(parseInt(hour, 10));
              slotDate.setMinutes(parseInt(min));
              me.model.setSelection(slotDate, me);
            });
        }
      }
    }
  };

  apptBook.CalendarTimeSlotsMobile.prototype.setSlots = function () {
    var dayRowEnable;
    var dayRow = this.timeSlotsContainer.find('tr');
    var dayRowLength = dayRow.length;
    var dayValue = 0;
    var findTimeSlotAvailableStatus;
    var slotCalendarView = dayRow.closest('.appt-book-overlay').hasClass('calendar-view');
    var verifyNoSlotAvailable = dayRow
      .closest('.date-picker-container')
      .find('.js-date-picker-no-slot');
    var timeslots = this.calData.timeslots,
      myDate = new Date(this.calData.myDate.getTime());

    myDate.setHours(0, 0, 0, 0);
    this.timeSlotsElems.removeClass('enabled').off('click');

    if (!timeslots) {
      return;
    }
    for (var i = 0, len = timeslots.length; i < len; i += 1) {
      var start = dateUtils.convertTimeString(timeslots[i].start_date),
        startDay = new Date(start.getTime());

      startDay.setHours(0, 0, 0, 0);
      if (startDay.getTime() === myDate.getTime()) {
        this.processSlot(
          start,
          dateUtils.convertTimeString(timeslots[i].end_date),
          this.timeSlotInterval
        );
      }
    }
    if (slotCalendarView) {
      for (dayValue = 0; dayValue < dayRowLength; dayValue += 1) {
        dayRowEnable = dayRow.eq(dayValue).find('td').hasClass('enabled');
        if (!dayRowEnable) {
          dayRow.eq(dayValue).addClass('hidden');
        }
      }
      findTimeSlotAvailableStatus = dayRow.find('td').filter('.enabled').first();
      if (!findTimeSlotAvailableStatus.length && slotCalendarView) {
        verifyNoSlotAvailable.removeClass('hidden');
      } else {
        verifyNoSlotAvailable.addClass('hidden');
      }
    }
  };

  apptBook.CalendarTimeSlotsMobile.prototype.setApptTime = function () {
    var me = this,
      apptDate = dateUtils.convertTimeString(this.calData.apptTime),
      apptTime = apptDate.getTime(),
      apptHour = apptDate.getHours().toString(),
      apptMinutes = ('0' + apptDate.getMinutes()).slice(-2),
      apptTimeDate = apptHour + ':' + apptMinutes;
  };

  /* End Mobile Time Slot Select */
  $.fn.reverseChildren = function () {
    return this.each(function () {
      var $this = $(this);
      $this.children().each(function () {
        $this.prepend(this);
      });
    });
  };
  var dateUtils = {
    // Source: http://stackoverflow.com/questions/497790
    // That's right, I copied it from Stack Overflow.
    convert: function (d) {
      // Converts the date in d to a date-object. The input can be:
      //   a date object: returned without modification
      //  an array      : Interpreted as [year,month,day]. NOTE: month is 0-11.
      //   a number     : Interpreted as number of milliseconds
      //                  since 1 Jan 1970 (a timestamp)
      //   a string     : Any format supported by the javascript engine, like
      //                  "YYYY/MM/DD", "MM/DD/YYYY", "Jan 31 2009" etc.
      //  an object     : Interpreted as an object with year, month and date
      //                  attributes.  **NOTE** month is 0-11.
      return d.constructor === Date
        ? d
        : d.constructor === Array
        ? new Date(d[0], d[1], d[2])
        : d.constructor === Number
        ? new Date(d)
        : d.constructor === String
        ? new Date(d)
        : typeof d === 'object'
        ? new Date(d.year, d.month, d.date)
        : NaN;
    },
    compare: function (a, b) {
      // Compare two dates (could be of any type supported by the convert
      // function above) and returns:
      //  -1 : if a < b
      //   0 : if a = b
      //   1 : if a > b
      // NaN : if a or b is an illegal date
      // NOTE: The code inside isFinite does an assignment (=).
      return isFinite((a = this.convert(a).valueOf())) && isFinite((b = this.convert(b).valueOf()))
        ? (a > b) - (a < b)
        : NaN;
    },
    inRange: function (d, start, end) {
      // Checks if date in d is between dates in start and end.
      // Returns a boolean or NaN:
      //    true  : if d is between start and end (inclusive)
      //    false : if d is before start or after end
      //    NaN   : if one or more of the dates is illegal.
      // NOTE: The code inside isFinite does an assignment (=).
      return isFinite((d = this.convert(d).valueOf())) &&
        isFinite((start = this.convert(start).valueOf())) &&
        isFinite((end = this.convert(end).valueOf()))
        ? start <= d && d < end
        : NaN;
    },
    dateToString: function (date, format) {
      var str = date.toLocaleString();

      switch (format) {
        case 'yyyy-mm-dd':
          var thisMonthString = date.getMonth() + 1;

          thisMonthString = thisMonthString < 10 ? '0' + thisMonthString : '' + thisMonthString;
          var thisDateString = date.getDate();

          thisDateString = thisDateString < 10 ? '0' + thisDateString : '' + thisDateString;
          str = date.getFullYear() + '-';
          str += thisMonthString + '-';
          str += thisDateString;
          break;
        default:
          break;
      }

      return str;
    },
    // tests 2 date ranges for overlap
    // @param r1 Array required [start date, end date]
    // @param r2 Array required [start date, end date]
    compareRanges: function (r1, r2) {
      if (r2[0] > r1[1]) {
        return false;
      }
      if (r2[1] < r1[0]) {
        return false;
      }

      return true;
    },
    //
    // converts string to date object, from format "yyyy-mm-dd hh:MM" ONLY
    convertTimeString: function (tString) {
      var split, dateArray, timeArray, y, m, d, hr, min, sec;

      split = tString.split(' ');
      dateArray = split[0].split('-');
      timeArray = split[1].split(':');

      y = parseInt(dateArray[0], 10);
      m = parseInt(dateArray[1], 10) - 1;
      d = parseInt(dateArray[2], 10);
      hr = parseInt(timeArray[0], 10);
      min = parseInt(timeArray[1], 10);
      sec = parseInt(timeArray[2], 10);

      return new Date(y, m, d, hr, min, sec);
    }
  }; // end dateUtils

  Drupal.appointmentBooking.dateUtils = dateUtils;

  Drupal.behaviors.apptBookAppointments = {
    attach: function (context) {
      var self = this;
      var view = new apptBook.AppointmentSelectSection($('#appointments'));

      if (view.momentLocale) {
        moment.locale(view.momentLocale);
      }
      view.setModel(apptBook.sectionModel).startObserving();
      if (!site.client.isMobile) {
        // $("#appointments .selectbox").selectBox().selectBox('settings', { menuTransition: 'slide', menuSpeed: 'fast' });
      }
      $('.artist-info', context).on('click', function () {
        $.colorbox.remove();
        var artist_node = $('#appointments', context).attr('data-artist-node');

        $.ajax({
          url: 'https://' + window.location.host + '/elc_api/' + artist_node + '/',
          type: 'GET',
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Accept', 'HTML');
          },
          success: function (data) {
            var content =
              '<div class="app-artist-info">' +
              $('#' + artist_node.replace('/', '-') + ' .content', data.rendered).html() +
              '</div>';
            var artistDescLimit = 200;
            var colorboxSettings = {
              html: content,
              close: '<i class="icon--remove"></i>',
              className: 'appt-artist-overlay',
              width: '60%',
              transition: 'none',
              opacity: '0.7',
              onComplete: function () {
                var cboxContent = $('#cboxContent');

                $('#cboxLoadedContent', cboxContent).css({ width: '100%' });
                $('.app-artist-info', cboxContent).slick({
                  slidesToShow: 2,
                  slidesToScroll: 1,
                  variableWidth: true,
                  infinite: false,
                  responsive: [
                    {
                      breakpoint: 640,
                      settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true,
                        arrows: false,
                        centerMode: true
                      }
                    }
                  ]
                });
                $('.artist-description', cboxContent).each(function () {
                  var artistFullDesc = $(this).text();

                  if (artistFullDesc.length > artistDescLimit) {
                    var firstSet = artistFullDesc.substring(0, artistDescLimit);
                    var secondHalf = artistFullDesc.substring(
                      artistDescLimit,
                      artistFullDesc.length
                    );

                    $(this).empty().html(firstSet);
                    $(this).append('<a href="javascript:void(0);" class="read-more">...</a>');
                    $(this).append('<span class="more-text hidden">' + secondHalf + '</span>');
                  }
                });
                $('.read-more', cboxContent).click(function () {
                  $(this).parent().find('.more-text').removeClass('hidden');
                  $(this).parent().find('.read-more').addClass('hidden');
                });
                $('.slick-dots li button, .slick-prev, .slick-next', cboxContent).click(
                  function () {
                    $('.artist-description', cboxContent).each(function () {
                      $(this).find('.more-text').addClass('hidden');
                      $(this).find('.read-more').removeClass('hidden');
                    });
                  }
                );
              }
            };
            var colorboxPcSettings = {
              width: '680px',
              height: '410px'
            };
            var colorboxMobileSettings = {
              width: '90%',
              height: '420px'
            };
            var overlay = $.extend(
              {},
              colorboxSettings,
              +site.client.isMobile ? colorboxMobileSettings : colorboxPcSettings
            );

            self.openWindow(overlay);
          }
        });
      });
    },
    openWindow: function (overlay) {
      $.colorbox(overlay);
    }
  };
})(jQuery);
